import type { Translations } from "./types";

const en: Translations = {
    "aboutDS160Page.description": "Common Questions and Answers about the US DS-160 Visa Form",
    "aboutDS160Page.title": "About DS160",
    "activateAccountPage.activate": "Activate your account",
    "activateAccountPage.activationCode": "6 digit activation code",
    "activateAccountPage.description": "Activate your headbot account",
    "activateAccountPage.instructions": "We've sent an activation code to your email.",
    "activateAccountPage.logout": "Logout",
    "activateAccountPage.title": "Activate your account",
    "addMemberModal.addMemberButton": "Add Member",
    "addMemberModal.addingButton": "Adding...",
    "addMemberModal.adminRole": "Admin",
    "addMemberModal.cancelButton": "Cancel",
    "addMemberModal.close": "Close",
    "addMemberModal.description": "Add a team member to this workspace. They must already have a SalesDingo account.",
    "addMemberModal.emailLabel": "Email address",
    "addMemberModal.emailPlaceholder": "Enter email address",
    "addMemberModal.memberRole": "Member",
    "addMemberModal.roleDescription": "Members can view and edit forms. Admins can also manage team members.",
    "addMemberModal.roleLabel": "Role",
    "addMemberModal.title": "Add Team Member",
    "alertModal.error": "Oops",
    "alertModal.ok": "Ok",
    "alertModal.success": "Success",
    "applicationShell.closeSidebar": "Close sidebar",
    "applicationShell.dashboard": "Dashboard",
    "applicationShell.navigation.dashboard": "Dashboard",
    "applicationShell.navigation.forms": "Forms",
    "applicationShell.navigation.leadQualification": "Lead Qualification",
    "applicationShell.navigation.leadTiering": "Lead Tiering",
    "applicationShell.navigation.myPurchases": "My Purchases",
    "applicationShell.navigation.submissions": "Submissions",
    "applicationShell.navigation.supportUs": "Support Us",
    "applicationShell.navigation.artifacts": "Artifacts",
    "applicationShell.navigation.emails": "Emails",
    "applicationShell.navigation.emailSettings": "Email Settings",
    "applicationShell.navigation.integrations": "Integrations",
    "applicationShell.navigation.companySearches": "Company Searches",
    "applicationShell.navigation.salesAccounts": "Sales Accounts",
    "applicationShell.navigation.segments": "Segments",
    "applicationShell.navigation.workflows": "Workflows",
    "applicationShell.navigation.workflowsActiveCount_one": "{{count}} workflow running",
    "applicationShell.navigation.workflowsActiveCount_other": "{{count}} workflows running",
    "applicationShell.navigation.workspaceSettings": "Workspace Settings",
    "applicationShell.openSidebar": "Open sidebar",
    "blogIndexPage.readMore": "Read more",
    "blogIndexPage.readingTime": "{{minutes}} min read",
    "blogIndexPage.title": "Blog",
    "checkoutPage.cart.couponCode": "Coupon code",
    "checkoutPage.cart.heading": "Items in your shopping cart",
    "checkoutPage.cart.productImageAlt": "DS160 Form Pilot Submission Icon",
    "checkoutPage.cart.productName": "DS160 Form Pilot Submission",
    "checkoutPage.cart.quantity": "Quantity",
    "checkoutPage.cart.unitPrice": "Unit Price",
    "checkoutPage.orderSummary.heading": "Order summary",
    "checkoutPage.orderSummary.subtotal": "Subtotal",
    "checkoutPage.orderSummary.taxNote": "Taxes will be calculated at checkout.",
    "checkoutPage.title": "Checkout",
    "clientIntake.address": "Address",
    "clientIntake.contactForAssistance": "Please contact the person who sent you this link for assistance.",
    "clientIntake.email": "Email",
    "clientIntake.formSectionListPage.description":
        "Please complete each section of your DS-160 visa application form. Your visa consultant will review your responses and assist with the submission process.",
    "clientIntake.formSectionListPage.heading": "DS-160 Application Sections",
    "clientIntake.formSectionListPage.note":
        "Important: All responses must be provided in English as required by the U.S. State Department. Your consultant will guide you through any questions you may have.",
    "clientIntake.formSectionListPage.table.editButton": "Edit",
    "clientIntake.formSectionListPage.table.headers.questionsAnswered": "Questions Completed",
    "clientIntake.formSectionListPage.table.headers.sectionName": "Section",
    "clientIntake.formSectionListPage.table.headers.status": "Status",
    "clientIntake.phone": "Phone",
    "clientIntakeEditFormPage.contactForAssistance": "Please contact the person who sent you this link for assistance.",
    "clientIntakeOverviewPage.contactForAssistance": "Please contact the person who sent you this link for assistance.",
    "clientIntakePage.contactForAssistance": "Please contact the person who sent you this link for assistance.",
    "clientIntakePage.continueEditing": "Continue Editing",
    "clientIntakePage.description":
        "You've been invited to complete a DS-160 visa application form. This secure portal will guide you through each section step by step.",
    "clientIntakePage.formNotFound": "Form not found or access denied",
    "clientIntakePage.getStarted": "Get Started",
    "clientIntakePage.invalidToken": "Invalid or expired access link",
    "clientIntakePage.loadingForm": "Loading your form...",
    "clientIntakePage.title": "Complete Your DS-160 Form",
    "clientIntakePage.tokenExpired": "This access link has expired",
    "clientIntakePage.welcomeMessage": "Welcome! You have secure access to complete your DS-160 visa application.",
    "clientLinkPage.accessDenied": "Access Denied",
    "clientLinkPage.accessId": "Access ID",
    "clientLinkPage.actions": "Actions",
    "clientLinkPage.activeLinks": "Active Client Links",
    "clientLinkPage.activeLinksDescription": "Manage existing client access links for this form",
    "clientLinkPage.backToForm": "Back to Form",
    "clientLinkPage.breadcrumb": "Create Client Link",
    "clientLinkPage.businessWorkspaceRequired": "Client links can only be created in business workspaces.",
    "clientLinkPage.cancel": "Cancel",
    "clientLinkPage.clientEmail": "Client Email",
    "clientLinkPage.clientEmailPlaceholder": "client@example.com",
    "clientLinkPage.clientName": "Client Name",
    "clientLinkPage.clientNamePlaceholder": "Enter client's full name",
    "clientLinkPage.confirmRevoke": "Are you sure you want to revoke this token? This action cannot be undone.",
    "clientLinkPage.copyLink": "Copy Link",
    "clientLinkPage.create": "Create Client Link",
    "clientLinkPage.createAnother": "Create Another Link",
    "clientLinkPage.createFirstLink": "Create your first client link to get started",
    "clientLinkPage.created": "Created",
    "clientLinkPage.creating": "Creating...",
    "clientLinkPage.defaultLanguage": "Default Language",
    "clientLinkPage.defaultLanguageHelp": "The language that will be shown when clients access the form.",
    "clientLinkPage.description": "Generate a secure link for your client to access this form with specific permissions.",
    "clientLinkPage.expires": "Expires",
    "clientLinkPage.expiresInDays": "Expires In (Days)",
    "clientLinkPage.expiresInDaysHelp": "The link will automatically expire after this many days. Default is 90 days.",
    "clientLinkPage.lastAccessed": "Last Accessed",
    "clientLinkPage.limitUsage": "Limit number of uses",
    "clientLinkPage.linkCopied": "Link copied to clipboard!",
    "clientLinkPage.linkCreated": "Link Created Successfully!",
    "clientLinkPage.linkCreatedDescription": "Your client link has been created and is ready to share.",
    "clientLinkPage.linkUrl": "Link URL",
    "clientLinkPage.maxUsagePlaceholder": "Maximum number of times this link can be used",
    "clientLinkPage.noActiveLinks": "No Active Links",
    "clientLinkPage.permission.fill": "Fill Form",
    "clientLinkPage.permission.fillDescription": "Allow client to enter and modify form data",
    "clientLinkPage.permission.read": "View Form",
    "clientLinkPage.permission.readDescription": "Allow client to view the form structure and fields",
    "clientLinkPage.permission.submit": "Submit Form",
    "clientLinkPage.permission.submitDescription": "Allow client to submit the completed form",
    "clientLinkPage.permission.view_status": "View Status",
    "clientLinkPage.permission.view_statusDescription": "Allow client to check submission status and results",
    "clientLinkPage.permissions": "Permissions",
    "clientLinkPage.revoke": "Revoke",
    "clientLinkPage.revokeToken": "Revoke Token",
    "clientLinkPage.revoking": "Revoking...",
    "clientLinkPage.shareableLink": "Shareable Link",
    "clientLinkPage.title": "Create Client Link",
    "common.save": "Save",
    "common.saving": "Saving...",
    "constants.loading": "Loading...",
    "constants.titleTag": "SalesDingo - Sales Automation",
    "csvPreview.columnCount": "{{count}} columns",
    "csvPreview.download": "Download CSV",
    "csvPreview.rowCount": "{{count}} rows",
    "csvPreview.showLess": "Show less",
    "csvPreview.showMore": "Show {{remaining}} more rows",
    "csvPreview.title": "CSV Preview",
    "dashboardPage.description": "Your DS160 Form Pilot Submissions",
    "dashboardPage.title": "Dashboard",
    "ds160ChecklistPage.description": "Free Checklist of items you will need to complete your DS-160 US Visa Form.",
    "ds160ChecklistPage.title": "DS160 Checklist",
    "editFormPage.description": "Edit your form responses",
    "editFormPage.title": "Edit Form",
    "footer.contact": "Email us",
    "footer.copyright": "© 2025-2026 SalesDingo",
    "footer.home": "Home",
    "footer.instagram": "Instagram",
    "footer.letsConnect": "Let's connect",
    "footer.privacy": "Privacy",
    "footer.tagLine": "Sales automation workflows",
    "footer.twitter": "Twitter",
    "formDuplicatePage.description": "Select sections to clone",
    "formDuplicatePage.title": "Clone Form",
    "formManifest.additionalOccupationPage.charitableOrganizations.subQuestions.yes.organizations.organizationName.title":
        "Organization Name",
    "formManifest.additionalOccupationPage.charitableOrganizations.subQuestions.yes.title": "Provide a List of Organizations",
    "formManifest.additionalOccupationPage.charitableOrganizations.title":
        "Have you belonged to, contributed to, or worked for any professional, social, or charitable organization?",
    "formManifest.additionalOccupationPage.clanOrTribe.subQuestions.yes.title": "Clan or tribe name",
    "formManifest.additionalOccupationPage.clanOrTribe.title": "Do you belong to a clan or tribe?",
    "formManifest.additionalOccupationPage.countriesVisitedLastFiveYears.subQuestions.yes.countriesVisited.country.title": "Country/Region",
    "formManifest.additionalOccupationPage.countriesVisitedLastFiveYears.subQuestions.yes.title":
        "Provide a List of Countries/Regions Visited",
    "formManifest.additionalOccupationPage.countriesVisitedLastFiveYears.title":
        "Have you traveled to any countries/regions within the last five years?",
    "formManifest.additionalOccupationPage.insurgentOrganization.subQuestions.yes.title": "Explain",
    "formManifest.additionalOccupationPage.insurgentOrganization.title":
        "Have you ever served in, been a member of, or been involved with a paramilitary unit, vigilante unit, rebel group, guerrilla group, or insurgent organization?",
    "formManifest.additionalOccupationPage.languages.languageName.title": "Language Name",
    "formManifest.additionalOccupationPage.languages.title": "Provide a List of Languages You Speak",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.branch.title": "Branch of Service",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.country.help.content":
        "Please select the current name of the country/region where you performed military service.",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.country.help.title":
        "Name of Country/Region",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.country.title": "Name of Country/Region",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.endDate.title": "Date of Service To",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.militarySpecialty.title":
        "Military Specialty",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.rank.title": "Rank/Position",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.militaryService.startDate.title": "Date of Service From",
    "formManifest.additionalOccupationPage.militaryExperience.subQuestions.yes.title": "Provide the following information:",
    "formManifest.additionalOccupationPage.militaryExperience.title": "Have you ever served in the military?",
    "formManifest.additionalOccupationPage.specialExplosivesTraining.subQuestions.yes.title": "Explain",
    "formManifest.additionalOccupationPage.specialExplosivesTraining.title":
        "Do you have any specialized skills or training, such as firearms, explosives, nuclear, biological, or chemical experience?",
    "formManifest.addressAndPhonePage.email.help.content":
        "You must provide an email address. The email address you provide will be used for correspondence purposes. Provide an email address that is secure and to which you have reasonable access.",
    "formManifest.addressAndPhonePage.email.help.title": "Email Address",
    "formManifest.addressAndPhonePage.email.title": "Email Address",
    "formManifest.addressAndPhonePage.hasAdditionalSocialMedia.subQuestions.yes.handle.title": "Additional Social Media Handle",
    "formManifest.addressAndPhonePage.hasAdditionalSocialMedia.subQuestions.yes.platform.title": "Additional Social Media Platform",
    "formManifest.addressAndPhonePage.hasAdditionalSocialMedia.subQuestions.yes.title":
        "Provide the following information for each website or application:",
    "formManifest.addressAndPhonePage.hasAdditionalSocialMedia.title":
        "Do you wish to provide information about your presence on any other websites or applications you have used within the last five years to create or share content (photos, videos, status updates, etc.)?",
    "formManifest.addressAndPhonePage.hasOtherEmails.subQuestions.yes.email.title": "Additional Email Address",
    "formManifest.addressAndPhonePage.hasOtherEmails.title": "Have you used any other email addresses in the last five years?",
    "formManifest.addressAndPhonePage.hasOtherPhoneNumbers.subQuestions.yes.phoneNumber.title": "Additional Phone Number",
    "formManifest.addressAndPhonePage.hasOtherPhoneNumbers.subQuestions.yes.title":
        "Provide the following information for each phone number:",
    "formManifest.addressAndPhonePage.hasOtherPhoneNumbers.title": "Have you used any other phone numbers in the last five years?",
    "formManifest.addressAndPhonePage.homeAddress.city.title": "City",
    "formManifest.addressAndPhonePage.homeAddress.country.title": "Country/Region",
    "formManifest.addressAndPhonePage.homeAddress.line1.title": "Street Address (Line 1)",
    "formManifest.addressAndPhonePage.homeAddress.line2.title": "Street Address (Line 2)",
    "formManifest.addressAndPhonePage.homeAddress.state.na.title": "Does not apply",
    "formManifest.addressAndPhonePage.homeAddress.state.title": "State/Province",
    "formManifest.addressAndPhonePage.homeAddress.title": "Home Address",
    "formManifest.addressAndPhonePage.homeAddress.zipCode.na.title": "Does not apply",
    "formManifest.addressAndPhonePage.homeAddress.zipCode.title": "Postal Zone/ZIP Code",
    "formManifest.addressAndPhonePage.mailingAddressType.help.content":
        "If your mailing address is different from your home address, please provide your mailing address.",
    "formManifest.addressAndPhonePage.mailingAddressType.help.title": "Mailing Address",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.city.title": "City",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.country.title": "Country/Region",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.line1.title": "Street Address (Line 1)",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.line2.title": "Street Address (Line 2)",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.state.na.title": "Does not apply",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.state.title": "State/Province",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.title": "Mailing Address",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.zipCode.na.title": "Does not apply",
    "formManifest.addressAndPhonePage.mailingAddressType.subQuestions.no.zipCode.title": "Postal Zone/ZIP Code",
    "formManifest.addressAndPhonePage.mailingAddressType.title": "Is your Mailing Address the same as your Home Address?",
    "formManifest.addressAndPhonePage.phoneNumbers.help.content":
        "You must provide a primary phone number. The primary phone number should be the phone number at which you are most likely to be reached; this could be a land line or a cellular/mobile number. If you have an additional land line or a cellular/mobile number please list that as your secondary phone number.",
    "formManifest.addressAndPhonePage.phoneNumbers.help.title": "Phone",
    "formManifest.addressAndPhonePage.phoneNumbers.primaryPhone.title": "Primary Phone Number",
    "formManifest.addressAndPhonePage.phoneNumbers.secondaryPhone.na.title": "Does not apply",
    "formManifest.addressAndPhonePage.phoneNumbers.secondaryPhone.title": "Secondary Phone Number",
    "formManifest.addressAndPhonePage.phoneNumbers.title": "Phone",
    "formManifest.addressAndPhonePage.phoneNumbers.workPhone.na.title": "Does not apply",
    "formManifest.addressAndPhonePage.phoneNumbers.workPhone.title": "Work Phone Number",
    "formManifest.addressAndPhonePage.socialMediaProfiles.help.content":
        "Enter information associated with your online presence, including the types of online providers/platforms, applications and websites that you use to collaborate, share information, and interact with others. List the username, handle, screen-name, or other identifiers associated with your social media profile. (You do not need to list accounts designed for use by multiple users within a business or other organization.)",
    "formManifest.addressAndPhonePage.socialMediaProfiles.help.title": "Social Media",
    "formManifest.addressAndPhonePage.socialMediaProfiles.identifier.title": "Social Media Identifier",
    "formManifest.addressAndPhonePage.socialMediaProfiles.platform.title": "Social Media Provider/Platform",
    "formManifest.addressAndPhonePage.socialMediaProfiles.title": "Social Media",
    "formManifest.contactInfoPage.contact.help.content":
        "Your U.S. Point of Contact can be any individual in the U.S. who knows you and can verify, if necessary, your identity. If you do not personally know anyone in the U.S., you may enter the name of the store, company, or organization you plan to visit during your trip.",
    "formManifest.contactInfoPage.contact.help.title": "Contact",
    "formManifest.contactInfoPage.contact.subQuestions.no.title": "Organization Name",
    "formManifest.contactInfoPage.contact.subQuestions.yes.givenNames.title": "Given Names",
    "formManifest.contactInfoPage.contact.subQuestions.yes.surnames.title": "Surnames",
    "formManifest.contactInfoPage.contact.subQuestions.yes.title": "Contact Person",
    "formManifest.contactInfoPage.contact.title": "Do you have a specific individual as your U.S. Point of Contact?",
    "formManifest.contactInfoPage.pointOfContact.addressLine1.title": "U.S. Street Address (Line 1)",
    "formManifest.contactInfoPage.pointOfContact.addressLine2.title": "U.S. Street Address (Line 2)",
    "formManifest.contactInfoPage.pointOfContact.city.title": "City",
    "formManifest.contactInfoPage.pointOfContact.email.na.title": "Does not apply",
    "formManifest.contactInfoPage.pointOfContact.email.title": "Email Address",
    "formManifest.contactInfoPage.pointOfContact.phone.title": "Phone Number",
    "formManifest.contactInfoPage.pointOfContact.state.title": "State",
    "formManifest.contactInfoPage.pointOfContact.title": "Address and Phone Number of Point of Contact",
    "formManifest.contactInfoPage.pointOfContact.zipCode.title": "ZIP Code (if known)",
    "formManifest.contactInfoPage.relationship.title": "Relationship To You",
    "formManifest.deceasedSpouseInfoPage.dateOfBirth.title": "Date of Birth",
    "formManifest.deceasedSpouseInfoPage.givenName.title": "Given Name",
    "formManifest.deceasedSpouseInfoPage.nationality.title": "Country/Region of Origin (Nationality)",
    "formManifest.deceasedSpouseInfoPage.placeOfBirth.city.na.title": "Do Not Know",
    "formManifest.deceasedSpouseInfoPage.placeOfBirth.city.title": "City",
    "formManifest.deceasedSpouseInfoPage.placeOfBirth.country.title": "Country/Region",
    "formManifest.deceasedSpouseInfoPage.placeOfBirth.title": "Deceased Spouse's Place of Birth",
    "formManifest.deceasedSpouseInfoPage.surname.title": "Surname",
    "formManifest.familyInfoPage.father.dateOfBirth.na.title": "Do not know",
    "formManifest.familyInfoPage.father.dateOfBirth.title": "Date of Birth",
    "formManifest.familyInfoPage.father.givenNames.na.title": "Do not know",
    "formManifest.familyInfoPage.father.givenNames.title": "Given Names",
    "formManifest.familyInfoPage.father.inUS.subQuestions.yes.title": "Father's Status",
    "formManifest.familyInfoPage.father.inUS.title": "Is your father in the U.S.?",
    "formManifest.familyInfoPage.father.surnames.na.title": "Do not know",
    "formManifest.familyInfoPage.father.surnames.title": "Surnames",
    "formManifest.familyInfoPage.father.title": "Father's Full Name and Date of Birth",
    "formManifest.familyInfoPage.hasImmediateRelatives.help.content":
        "Means fiancé/fiancée, spouse (husband/wife), child (son/daughter), or sibling (brother/sister).",
    "formManifest.familyInfoPage.hasImmediateRelatives.help.title": "Immediate Relatives",
    "formManifest.familyInfoPage.hasImmediateRelatives.subQuestions.no.hasOtherRelatives.title":
        "Do you have any other relatives in the United States?",
    "formManifest.familyInfoPage.hasImmediateRelatives.subQuestions.yes.givenNames.title": "Given Names",
    "formManifest.familyInfoPage.hasImmediateRelatives.subQuestions.yes.immigrationStatus.title": "Relative status",
    "formManifest.familyInfoPage.hasImmediateRelatives.subQuestions.yes.relationship.title": "Relationship To You",
    "formManifest.familyInfoPage.hasImmediateRelatives.subQuestions.yes.surnames.title": "Surnames",
    "formManifest.familyInfoPage.hasImmediateRelatives.subQuestions.yes.title": "Provide the following information:",
    "formManifest.familyInfoPage.hasImmediateRelatives.title":
        "Do you have any immediate relatives, not including parents, in the United States?",
    "formManifest.familyInfoPage.immigrationStatus.nonimmigrant": "Nonimmigrant",
    "formManifest.familyInfoPage.immigrationStatus.otherIDontKnow": "Other/I Don't Know",
    "formManifest.familyInfoPage.immigrationStatus.usCitizen": "U.S. Citizen",
    "formManifest.familyInfoPage.immigrationStatus.usLegalPermanentResident": "U.S. Legal Permanent Resident (LPR)",
    "formManifest.familyInfoPage.mother.dateOfBirth.na.title": "Do not know",
    "formManifest.familyInfoPage.mother.dateOfBirth.title": "Date of Birth",
    "formManifest.familyInfoPage.mother.givenNames.na.title": "Do not know",
    "formManifest.familyInfoPage.mother.givenNames.title": "Given Names",
    "formManifest.familyInfoPage.mother.inUS.subQuestions.yes.title": "Mother's Status",
    "formManifest.familyInfoPage.mother.inUS.title": "Is your mother in the U.S.?",
    "formManifest.familyInfoPage.mother.surnames.na.title": "Do not know",
    "formManifest.familyInfoPage.mother.surnames.title": "Surnames",
    "formManifest.familyInfoPage.mother.title": "Mother's Full Name and Date of Birth",
    "formManifest.passportPage.hasLostPassports.subQuestions.yes.country.title": "Country/Authority that Issued Passport/Travel Document",
    "formManifest.passportPage.hasLostPassports.subQuestions.yes.explanation.title": "Explain the Circumstances",
    "formManifest.passportPage.hasLostPassports.subQuestions.yes.passportNumber.na.title": "Do not know",
    "formManifest.passportPage.hasLostPassports.subQuestions.yes.passportNumber.title": "Passport/Travel Document Number",
    "formManifest.passportPage.hasLostPassports.subQuestions.yes.title":
        "Provide the following information for each lost or stolen passport:",
    "formManifest.passportPage.hasLostPassports.title": "Have you ever lost a passport or had one stolen?",
    "formManifest.passportPage.issuedByCountry.title": "Country/Authority that Issued Passport/Travel Document",
    "formManifest.passportPage.passportBookNumber.help.content":
        "The Passport Book Number is commonly called the inventory control number. You may or may not have a Passport Book Number on your passport. The location of the Passport Book Number on your passport may vary depending on the country that issued your passport. Please contact your passport issuing authority if you are unable to determine whether or not your passport contains a Passport Book Number.",
    "formManifest.passportPage.passportBookNumber.help.title": "Passport Book Number",
    "formManifest.passportPage.passportBookNumber.na.title": "Does not apply",
    "formManifest.passportPage.passportBookNumber.title": "Passport Book Number",
    "formManifest.passportPage.passportDocumentNumber.help.content":
        "Enter the information on the travel document you will be using when traveling to the U.S. Your travel document should be a valid, unexpired passport or other valid, unexpired documentation that is sufficient to establish your identity and nationality.",
    "formManifest.passportPage.passportDocumentNumber.help.title": "Passport/Travel Document Number",
    "formManifest.passportPage.passportDocumentNumber.title": "Passport/Travel Document Number",
    "formManifest.passportPage.passportIssuanceDetails.expirationDate.help.content":
        "In most cases your passport/Travel Document must have at least six months of validity beyond the date of your visa application and/or your arrival in the United States.",
    "formManifest.passportPage.passportIssuanceDetails.expirationDate.help.title": "Expiration Date",
    "formManifest.passportPage.passportIssuanceDetails.expirationDate.na.title": "No expiration",
    "formManifest.passportPage.passportIssuanceDetails.expirationDate.title": "Expiration Date",
    "formManifest.passportPage.passportIssuanceDetails.issueDate.title": "Issuance Date",
    "formManifest.passportPage.passportIssuanceDetails.issuedInCity.title": "City",
    "formManifest.passportPage.passportIssuanceDetails.issuedInCountry.title": "Country/Region",
    "formManifest.passportPage.passportIssuanceDetails.issuedInState.title": "State/Province *If shown on passport",
    "formManifest.passportPage.passportIssuanceDetails.title": "Where was the Passport/Travel Document Issued?",
    "formManifest.passportPage.passportType.diplomatic": "Diplomatic",
    "formManifest.passportPage.passportType.laissezPasser": "Laissez Passer",
    "formManifest.passportPage.passportType.official": "Official",
    "formManifest.passportPage.passportType.other": "Other",
    "formManifest.passportPage.passportType.regular": "Regular",
    "formManifest.passportPage.passportType.title": "Passport/Travel Document Type",
    "formManifest.personalP1.birthCity.title": "City of Birth",
    "formManifest.personalP1.birthCountry.AFGH": "AFGHANISTAN",
    "formManifest.personalP1.birthCountry.AGS": "MEXICO - AGUASCALIENTES",
    "formManifest.personalP1.birthCountry.ALB": "ALBANIA",
    "formManifest.personalP1.birthCountry.ALGR": "ALGERIA",
    "formManifest.personalP1.birthCountry.ANDO": "ANDORRA",
    "formManifest.personalP1.birthCountry.ANGL": "ANGOLA",
    "formManifest.personalP1.birthCountry.ANGU": "ANGUILLA",
    "formManifest.personalP1.birthCountry.ANTI": "ANTIGUA AND BARBUDA",
    "formManifest.personalP1.birthCountry.ARB": "ARUBA",
    "formManifest.personalP1.birthCountry.ARG": "ARGENTINA",
    "formManifest.personalP1.birthCountry.ARM": "ARMENIA",
    "formManifest.personalP1.birthCountry.ASMO": "AMERICAN SAMOA",
    "formManifest.personalP1.birthCountry.ASTL": "AUSTRALIA",
    "formManifest.personalP1.birthCountry.AUST": "AUSTRIA",
    "formManifest.personalP1.birthCountry.AZR": "AZERBAIJAN",
    "formManifest.personalP1.birthCountry.BAHR": "BAHRAIN",
    "formManifest.personalP1.birthCountry.BAMA": "BAHAMAS",
    "formManifest.personalP1.birthCountry.BANG": "BANGLADESH",
    "formManifest.personalP1.birthCountry.BC": "MEXICO - BAJA CALIFORNIA NORTE",
    "formManifest.personalP1.birthCountry.BCSR": "MEXICO - BAJA CALIFORNIA SUR",
    "formManifest.personalP1.birthCountry.BELG": "BELGIUM",
    "formManifest.personalP1.birthCountry.BENN": "BENIN",
    "formManifest.personalP1.birthCountry.BERM": "BERMUDA",
    "formManifest.personalP1.birthCountry.BHU": "BHUTAN",
    "formManifest.personalP1.birthCountry.BIH": "BOSNIA-HERZEGOVINA",
    "formManifest.personalP1.birthCountry.BLZ": "BELIZE",
    "formManifest.personalP1.birthCountry.BOL": "BOLIVIA",
    "formManifest.personalP1.birthCountry.BON": "BONAIRE",
    "formManifest.personalP1.birthCountry.BOT": "BOTSWANA",
    "formManifest.personalP1.birthCountry.BRDO": "BARBADOS",
    "formManifest.personalP1.birthCountry.BRND": "BURUNDI",
    "formManifest.personalP1.birthCountry.BRNI": "BRUNEI",
    "formManifest.personalP1.birthCountry.BRVI": "VIRGIN ISLANDS, BRITISH",
    "formManifest.personalP1.birthCountry.BRZL": "BRAZIL",
    "formManifest.personalP1.birthCountry.BULG": "BULGARIA",
    "formManifest.personalP1.birthCountry.BURK": "BURKINA FASO",
    "formManifest.personalP1.birthCountry.BURM": "BURMA",
    "formManifest.personalP1.birthCountry.BYS": "BELARUS",
    "formManifest.personalP1.birthCountry.CAFR": "CENTRAL AFRICAN REPUBLIC",
    "formManifest.personalP1.birthCountry.CAMP": "MEXICO - CAMPECHE",
    "formManifest.personalP1.birthCountry.CAN": "CANADA",
    "formManifest.personalP1.birthCountry.CAVI": "CABO VERDE",
    "formManifest.personalP1.birthCountry.CAYI": "CAYMAN ISLANDS",
    "formManifest.personalP1.birthCountry.CBDA": "CAMBODIA",
    "formManifest.personalP1.birthCountry.CHAD": "CHAD",
    "formManifest.personalP1.birthCountry.CHIH": "MEXICO - CHIHUAHUA",
    "formManifest.personalP1.birthCountry.CHIL": "CHILE",
    "formManifest.personalP1.birthCountry.CHIN": "CHINA",
    "formManifest.personalP1.birthCountry.CHIS": "MEXICO - CHIAPAS",
    "formManifest.personalP1.birthCountry.CHRI": "CHRISTMAS ISLAND",
    "formManifest.personalP1.birthCountry.CKIS": "COOK ISLANDS",
    "formManifest.personalP1.birthCountry.CMRN": "CAMEROON",
    "formManifest.personalP1.birthCountry.COAH": "MEXICO - COAHUILA",
    "formManifest.personalP1.birthCountry.COCI": "COCOS KEELING ISLANDS",
    "formManifest.personalP1.birthCountry.COD": "CONGO, DEMOCRATIC REPUBLIC OF THE",
    "formManifest.personalP1.birthCountry.CODI": "COTE D`IVOIRE",
    "formManifest.personalP1.birthCountry.COIS": "COOK ISLANDS",
    "formManifest.personalP1.birthCountry.COL": "COLOMBIA",
    "formManifest.personalP1.birthCountry.COLI": "MEXICO - COLIMA",
    "formManifest.personalP1.birthCountry.COMO": "COMOROS",
    "formManifest.personalP1.birthCountry.CONB": "CONGO, REPUBLIC OF THE",
    "formManifest.personalP1.birthCountry.CORI": "COSTA RICA",
    "formManifest.personalP1.birthCountry.CROA": "CROATIA",
    "formManifest.personalP1.birthCountry.CSTR": "COSTA RICA",
    "formManifest.personalP1.birthCountry.CUBA": "CUBA",
    "formManifest.personalP1.birthCountry.CUR": "CURACAO",
    "formManifest.personalP1.birthCountry.CURA": "CURACAO",
    "formManifest.personalP1.birthCountry.CYP": "CYPRUS",
    "formManifest.personalP1.birthCountry.CYPR": "CYPRUS",
    "formManifest.personalP1.birthCountry.CZEC": "CZECH REPUBLIC",
    "formManifest.personalP1.birthCountry.DEN": "DENMARK",
    "formManifest.personalP1.birthCountry.DF": "MEXICO - DISTRITO FEDERAL",
    "formManifest.personalP1.birthCountry.DGO": "MEXICO - DURANGO",
    "formManifest.personalP1.birthCountry.DJI": "DJIBOUTI",
    "formManifest.personalP1.birthCountry.DJIB": "DJIBOUTI",
    "formManifest.personalP1.birthCountry.DOMA": "DOMINICA",
    "formManifest.personalP1.birthCountry.DOMN": "DOMINICA",
    "formManifest.personalP1.birthCountry.DOMR": "DOMINICAN REPUBLIC",
    "formManifest.personalP1.birthCountry.DROC": "CONGO, DEMOCRATIC REPUBLIC OF THE",
    "formManifest.personalP1.birthCountry.EATI": "TIMOR-LESTE",
    "formManifest.personalP1.birthCountry.ECU": "ECUADOR",
    "formManifest.personalP1.birthCountry.ECUA": "ECUADOR",
    "formManifest.personalP1.birthCountry.EGN": "EQUATORIAL GUINEA",
    "formManifest.personalP1.birthCountry.EGY": "EGYPT",
    "formManifest.personalP1.birthCountry.EGYP": "EGYPT",
    "formManifest.personalP1.birthCountry.ELSA": "EL SALVADOR",
    "formManifest.personalP1.birthCountry.ELSL": "EL SALVADOR",
    "formManifest.personalP1.birthCountry.EQUG": "EQUATORIAL GUINEA",
    "formManifest.personalP1.birthCountry.ERI": "ERITREA",
    "formManifest.personalP1.birthCountry.ERIT": "ERITREA",
    "formManifest.personalP1.birthCountry.EST": "ESTONIA",
    "formManifest.personalP1.birthCountry.ETH": "ETHIOPIA",
    "formManifest.personalP1.birthCountry.FALI": "FALKLAND ISLANDS",
    "formManifest.personalP1.birthCountry.FARI": "FAROE ISLANDS",
    "formManifest.personalP1.birthCountry.FIJI": "FIJI",
    "formManifest.personalP1.birthCountry.FIN": "FINLAND",
    "formManifest.personalP1.birthCountry.FKLI": "FALKLAND ISLANDS",
    "formManifest.personalP1.birthCountry.FPOL": "FRENCH POLYNESIA",
    "formManifest.personalP1.birthCountry.FR": "FRANCE",
    "formManifest.personalP1.birthCountry.FRAN": "FRANCE",
    "formManifest.personalP1.birthCountry.FRGU": "FRENCH GUIANA",
    "formManifest.personalP1.birthCountry.FRO": "FAROE ISLANDS",
    "formManifest.personalP1.birthCountry.FRPO": "FRENCH POLYNESIA",
    "formManifest.personalP1.birthCountry.FRST": "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES",
    "formManifest.personalP1.birthCountry.FSAT": "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES",
    "formManifest.personalP1.birthCountry.FSM": "MICRONESIA",
    "formManifest.personalP1.birthCountry.GAB": "GABON",
    "formManifest.personalP1.birthCountry.GABN": "GABON",
    "formManifest.personalP1.birthCountry.GAM": "GAMBIA, THE",
    "formManifest.personalP1.birthCountry.GEO": "GEORGIA",
    "formManifest.personalP1.birthCountry.GEOR": "GEORGIA",
    "formManifest.personalP1.birthCountry.GER": "GERMANY",
    "formManifest.personalP1.birthCountry.GHA": "GHANA",
    "formManifest.personalP1.birthCountry.GHAN": "GHANA",
    "formManifest.personalP1.birthCountry.GIB": "GIBRALTAR",
    "formManifest.personalP1.birthCountry.GNEA": "GUINEA",
    "formManifest.personalP1.birthCountry.GRBR": "UNITED KINGDOM",
    "formManifest.personalP1.birthCountry.GRC": "GREECE",
    "formManifest.personalP1.birthCountry.GREN": "GRENADA",
    "formManifest.personalP1.birthCountry.GRLD": "GREENLAND",
    "formManifest.personalP1.birthCountry.GRO": "MEXICO - GUERRERO",
    "formManifest.personalP1.birthCountry.GTO": "MEXICO - GUANAJUATO",
    "formManifest.personalP1.birthCountry.GUAD": "GUADELOUPE",
    "formManifest.personalP1.birthCountry.GUAM": "GUAM",
    "formManifest.personalP1.birthCountry.GUAT": "GUATEMALA",
    "formManifest.personalP1.birthCountry.GUI": "GUINEA",
    "formManifest.personalP1.birthCountry.GUIB": "GUINEA - BISSAU",
    "formManifest.personalP1.birthCountry.GUY": "GUYANA",
    "formManifest.personalP1.birthCountry.HAI": "HAITI",
    "formManifest.personalP1.birthCountry.HAT": "HAITI",
    "formManifest.personalP1.birthCountry.HEMI": "HEARD AND MCDONALD ISLANDS",
    "formManifest.personalP1.birthCountry.HGO": "MEXICO - HIDALGO",
    "formManifest.personalP1.birthCountry.HMD": "HEARD AND MCDONALD ISLANDS",
    "formManifest.personalP1.birthCountry.HNK": "HONG KONG SAR",
    "formManifest.personalP1.birthCountry.HOKO": "HONG KONG BNO",
    "formManifest.personalP1.birthCountry.HON": "HONDURAS",
    "formManifest.personalP1.birthCountry.HOND": "HONDURAS",
    "formManifest.personalP1.birthCountry.HOSE": "HOLY SEE (VATICAN CITY)",
    "formManifest.personalP1.birthCountry.HRV": "CROATIA",
    "formManifest.personalP1.birthCountry.HUN": "HUNGARY",
    "formManifest.personalP1.birthCountry.HUNG": "HUNGARY",
    "formManifest.personalP1.birthCountry.ICE": "ICELAND",
    "formManifest.personalP1.birthCountry.ICLD": "ICELAND",
    "formManifest.personalP1.birthCountry.IDSA": "INDONESIA",
    "formManifest.personalP1.birthCountry.IND": "INDIA",
    "formManifest.personalP1.birthCountry.INDO": "INDONESIA",
    "formManifest.personalP1.birthCountry.IOT": "BRITISH INDIAN OCEAN TERRITORY",
    "formManifest.personalP1.birthCountry.IRAN": "IRAN",
    "formManifest.personalP1.birthCountry.IRAQ": "IRAQ",
    "formManifest.personalP1.birthCountry.IRE": "IRELAND",
    "formManifest.personalP1.birthCountry.ISR": "ISRAEL",
    "formManifest.personalP1.birthCountry.ISRL": "ISRAEL",
    "formManifest.personalP1.birthCountry.ITA": "ITALY",
    "formManifest.personalP1.birthCountry.ITLY": "ITALY",
    "formManifest.personalP1.birthCountry.IVCO": "COTE D`IVOIRE",
    "formManifest.personalP1.birthCountry.JAL": "MEXICO - JALISCO",
    "formManifest.personalP1.birthCountry.JAM": "JAMAICA",
    "formManifest.personalP1.birthCountry.JOR": "JORDAN",
    "formManifest.personalP1.birthCountry.JORD": "JORDAN",
    "formManifest.personalP1.birthCountry.JPN": "JAPAN",
    "formManifest.personalP1.birthCountry.JRSM": "JERUSALEM",
    "formManifest.personalP1.birthCountry.KAZ": "KAZAKHSTAN",
    "formManifest.personalP1.birthCountry.KEN": "KENYA",
    "formManifest.personalP1.birthCountry.KENY": "KENYA",
    "formManifest.personalP1.birthCountry.KGZ": "KYRGYZSTAN",
    "formManifest.personalP1.birthCountry.KIR": "KIRIBATI",
    "formManifest.personalP1.birthCountry.KIRI": "KIRIBATI",
    "formManifest.personalP1.birthCountry.KOR": "KOREA, REPUBLIC OF (SOUTH)",
    "formManifest.personalP1.birthCountry.KSV": "KOSOVO",
    "formManifest.personalP1.birthCountry.KUW": "KUWAIT",
    "formManifest.personalP1.birthCountry.KUWT": "KUWAIT",
    "formManifest.personalP1.birthCountry.KYR": "KYRGYZSTAN",
    "formManifest.personalP1.birthCountry.LAO": "LAOS",
    "formManifest.personalP1.birthCountry.LAOS": "LAOS",
    "formManifest.personalP1.birthCountry.LAT": "LATVIA",
    "formManifest.personalP1.birthCountry.LATV": "LATVIA",
    "formManifest.personalP1.birthCountry.LBYA": "LIBYA",
    "formManifest.personalP1.birthCountry.LCHT": "LIECHTENSTEIN",
    "formManifest.personalP1.birthCountry.LEB": "LEBANON",
    "formManifest.personalP1.birthCountry.LEBN": "LEBANON",
    "formManifest.personalP1.birthCountry.LES": "LESOTHO",
    "formManifest.personalP1.birthCountry.LIB": "LIBERIA",
    "formManifest.personalP1.birthCountry.LIBR": "LIBERIA",
    "formManifest.personalP1.birthCountry.LIBY": "LIBYA",
    "formManifest.personalP1.birthCountry.LIE": "LIECHTENSTEIN",
    "formManifest.personalP1.birthCountry.LITH": "LITHUANIA",
    "formManifest.personalP1.birthCountry.LUX": "LUXEMBOURG",
    "formManifest.personalP1.birthCountry.LXM": "LUXEMBOURG",
    "formManifest.personalP1.birthCountry.MAC": "MACAU",
    "formManifest.personalP1.birthCountry.MAD": "MADAGASCAR",
    "formManifest.personalP1.birthCountry.MADG": "MADAGASCAR",
    "formManifest.personalP1.birthCountry.MAF": "SAINT MARTIN",
    "formManifest.personalP1.birthCountry.MALA": "MALAWI",
    "formManifest.personalP1.birthCountry.MALD": "MALDIVES",
    "formManifest.personalP1.birthCountry.MALI": "MALI",
    "formManifest.personalP1.birthCountry.MALT": "MALTA",
    "formManifest.personalP1.birthCountry.MALW": "MALAWI",
    "formManifest.personalP1.birthCountry.MALY": "MALAYSIA",
    "formManifest.personalP1.birthCountry.MARS": "MARSHALL ISLANDS",
    "formManifest.personalP1.birthCountry.MART": "MARTINIQUE",
    "formManifest.personalP1.birthCountry.MAUR": "MAURITANIA",
    "formManifest.personalP1.birthCountry.MAURI": "MAURITIUS",
    "formManifest.personalP1.birthCountry.MAYO": "MAYOTTE",
    "formManifest.personalP1.birthCountry.MCH": "MEXICO - MICHOACAN",
    "formManifest.personalP1.birthCountry.MDWI": "MIDWAY ISLANDS",
    "formManifest.personalP1.birthCountry.MEX": "MEXICO",
    "formManifest.personalP1.birthCountry.MICR": "MICRONESIA",
    "formManifest.personalP1.birthCountry.MKD": "MACEDONIA, NORTH",
    "formManifest.personalP1.birthCountry.MLAS": "MALAYSIA",
    "formManifest.personalP1.birthCountry.MLD": "MOLDOVA",
    "formManifest.personalP1.birthCountry.MLDI": "MALDEN ISLAND",
    "formManifest.personalP1.birthCountry.MLDV": "MALDIVES",
    "formManifest.personalP1.birthCountry.MLTA": "MALTA",
    "formManifest.personalP1.birthCountry.MNP": "NORTH MARIANA ISLANDS",
    "formManifest.personalP1.birthCountry.MOLD": "MOLDOVA",
    "formManifest.personalP1.birthCountry.MON": "MONACO",
    "formManifest.personalP1.birthCountry.MONG": "MONGOLIA",
    "formManifest.personalP1.birthCountry.MONS": "MONTSERRAT",
    "formManifest.personalP1.birthCountry.MONT": "MONTSERRAT",
    "formManifest.personalP1.birthCountry.MOR": "MEXICO - MORELOS",
    "formManifest.personalP1.birthCountry.MORO": "MOROCCO",
    "formManifest.personalP1.birthCountry.MOZ": "MOZAMBIQUE",
    "formManifest.personalP1.birthCountry.MOZA": "MOZAMBIQUE",
    "formManifest.personalP1.birthCountry.MRTS": "MAURITIUS",
    "formManifest.personalP1.birthCountry.MTG": "MONTENEGRO",
    "formManifest.personalP1.birthCountry.MXCO": "MEXICO - STATE OF MEXICO",
    "formManifest.personalP1.birthCountry.MYA": "BURMA",
    "formManifest.personalP1.birthCountry.MYT": "MAYOTTE",
    "formManifest.personalP1.birthCountry.NAM": "NAMIBIA",
    "formManifest.personalP1.birthCountry.NAMB": "NAMIBIA",
    "formManifest.personalP1.birthCountry.NAU": "NAURU",
    "formManifest.personalP1.birthCountry.NAUR": "NAURU",
    "formManifest.personalP1.birthCountry.NAY": "MEXICO - NAYARIT",
    "formManifest.personalP1.birthCountry.NCAL": "NEW CALEDONIA",
    "formManifest.personalP1.birthCountry.NECA": "NEW CALEDONIA",
    "formManifest.personalP1.birthCountry.NEP": "NEPAL",
    "formManifest.personalP1.birthCountry.NETH": "NETHERLANDS",
    "formManifest.personalP1.birthCountry.NFK": "NORFOLK ISLAND",
    "formManifest.personalP1.birthCountry.NIC": "NICARAGUA",
    "formManifest.personalP1.birthCountry.NIGE": "NIGERIA",
    "formManifest.personalP1.birthCountry.NIGR": "NIGER",
    "formManifest.personalP1.birthCountry.NIR": "NIGER",
    "formManifest.personalP1.birthCountry.NIRE": "NORTHERN IRELAND",
    "formManifest.personalP1.birthCountry.NIUE": "NIUE",
    "formManifest.personalP1.birthCountry.NKOR": "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)",
    "formManifest.personalP1.birthCountry.NL": "MEXICO - NUEVO LEON",
    "formManifest.personalP1.birthCountry.NMAI": "NORTH MARIANA ISLANDS",
    "formManifest.personalP1.birthCountry.NOR": "NORWAY",
    "formManifest.personalP1.birthCountry.NORI": "NORFOLK ISLAND",
    "formManifest.personalP1.birthCountry.NORW": "NORWAY",
    "formManifest.personalP1.birthCountry.NRA": "NIGERIA",
    "formManifest.personalP1.birthCountry.NZEA": "NEW ZEALAND",
    "formManifest.personalP1.birthCountry.NZLD": "NEW ZEALAND",
    "formManifest.personalP1.birthCountry.OAX": "MEXICO - OAXACA",
    "formManifest.personalP1.birthCountry.OMAN": "OMAN",
    "formManifest.personalP1.birthCountry.PAK": "PAKISTAN",
    "formManifest.personalP1.birthCountry.PALA": "PALAU",
    "formManifest.personalP1.birthCountry.PAN": "PANAMA",
    "formManifest.personalP1.birthCountry.PAPN": "PAPUA NEW GUINEA",
    "formManifest.personalP1.birthCountry.PAR": "PARAGUAY",
    "formManifest.personalP1.birthCountry.PARA": "PARAGUAY",
    "formManifest.personalP1.birthCountry.PERU": "PERU",
    "formManifest.personalP1.birthCountry.PHIL": "PHILIPPINES",
    "formManifest.personalP1.birthCountry.PITC": "PITCAIRN ISLANDS",
    "formManifest.personalP1.birthCountry.PKST": "PAKISTAN",
    "formManifest.personalP1.birthCountry.PLMR": "PALMYRA ATOLL",
    "formManifest.personalP1.birthCountry.PNG": "PAPUA NEW GUINEA",
    "formManifest.personalP1.birthCountry.POL": "POLAND",
    "formManifest.personalP1.birthCountry.PORT": "PORTUGAL",
    "formManifest.personalP1.birthCountry.PR": "PUERTO RICO",
    "formManifest.personalP1.birthCountry.PRK": "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)",
    "formManifest.personalP1.birthCountry.PUE": "MEXICO - PUEBLA",
    "formManifest.personalP1.birthCountry.PUER": "PUERTO RICO",
    "formManifest.personalP1.birthCountry.QAT": "QATAR",
    "formManifest.personalP1.birthCountry.QRO": "MEXICO - QUERETARO",
    "formManifest.personalP1.birthCountry.QROO": "MEXICO - QUINTANA ROO",
    "formManifest.personalP1.birthCountry.QTAR": "QATAR",
    "formManifest.personalP1.birthCountry.RCON": "CONGO, REPUBLIC OF THE",
    "formManifest.personalP1.birthCountry.REU": "REUNION",
    "formManifest.personalP1.birthCountry.RMI": "MARSHALL ISLANDS",
    "formManifest.personalP1.birthCountry.ROM": "ROMANIA",
    "formManifest.personalP1.birthCountry.RUS": "RUSSIA",
    "formManifest.personalP1.birthCountry.RWA": "RWANDA",
    "formManifest.personalP1.birthCountry.RWND": "RWANDA",
    "formManifest.personalP1.birthCountry.SAFR": "SOUTH AFRICA",
    "formManifest.personalP1.birthCountry.SAHE": "ST. HELENA",
    "formManifest.personalP1.birthCountry.SAKN": "ST. KITTS AND NEVIS",
    "formManifest.personalP1.birthCountry.SALU": "ST. LUCIA",
    "formManifest.personalP1.birthCountry.SAM": "SAMOA",
    "formManifest.personalP1.birthCountry.SAMA": "SAINT MARTIN",
    "formManifest.personalP1.birthCountry.SANM": "SAN MARINO",
    "formManifest.personalP1.birthCountry.SAPM": "ST. PIERRE AND MIQUELON",
    "formManifest.personalP1.birthCountry.SARB": "SAUDI ARABIA",
    "formManifest.personalP1.birthCountry.SATP": "SAO TOME AND PRINCIPE",
    "formManifest.personalP1.birthCountry.SAUD": "SAUDI ARABIA",
    "formManifest.personalP1.birthCountry.SAVG": "ST. VINCENT AND THE GRENADINES",
    "formManifest.personalP1.birthCountry.SBA": "SERBIA",
    "formManifest.personalP1.birthCountry.SEN": "SENEGAL",
    "formManifest.personalP1.birthCountry.SENG": "SENEGAL",
    "formManifest.personalP1.birthCountry.SERB": "SERBIA",
    "formManifest.personalP1.birthCountry.SEYC": "SEYCHELLES",
    "formManifest.personalP1.birthCountry.SGS": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND",
    "formManifest.personalP1.birthCountry.SGSS": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND",
    "formManifest.personalP1.birthCountry.SHEL": "ST. HELENA",
    "formManifest.personalP1.birthCountry.SILE": "SIERRA LEONE",
    "formManifest.personalP1.birthCountry.SIN": "MEXICO - SINALOA",
    "formManifest.personalP1.birthCountry.SING": "SINGAPORE",
    "formManifest.personalP1.birthCountry.SINM": "SINT MAARTEN",
    "formManifest.personalP1.birthCountry.SJM": "SVALBARD",
    "formManifest.personalP1.birthCountry.SKOR": "KOREA, REPUBLIC OF (SOUTH)",
    "formManifest.personalP1.birthCountry.SLCA": "ST. LUCIA",
    "formManifest.personalP1.birthCountry.SLEO": "SIERRA LEONE",
    "formManifest.personalP1.birthCountry.SLMN": "SOLOMON ISLANDS",
    "formManifest.personalP1.birthCountry.SLP": "MEXICO - SAN LUIS POTOSI",
    "formManifest.personalP1.birthCountry.SLVK": "SLOVAKIA",
    "formManifest.personalP1.birthCountry.SLVN": "SLOVENIA",
    "formManifest.personalP1.birthCountry.SMAR": "SAN MARINO",
    "formManifest.personalP1.birthCountry.SOAF": "SOUTH AFRICA",
    "formManifest.personalP1.birthCountry.SOLI": "SOLOMON ISLANDS",
    "formManifest.personalP1.birthCountry.SOM": "SOMALIA",
    "formManifest.personalP1.birthCountry.SOMA": "SOMALIA",
    "formManifest.personalP1.birthCountry.SON": "MEXICO - SONORA",
    "formManifest.personalP1.birthCountry.SPA": "SPAIN",
    "formManifest.personalP1.birthCountry.SPMI": "ST. PIERRE AND MIQUELON",
    "formManifest.personalP1.birthCountry.SPN": "SPAIN",
    "formManifest.personalP1.birthCountry.SRIL": "SRI LANKA",
    "formManifest.personalP1.birthCountry.SRL": "SRI LANKA",
    "formManifest.personalP1.birthCountry.SSAH": "WESTERN SAHARA",
    "formManifest.personalP1.birthCountry.SSDN": "SOUTH SUDAN",
    "formManifest.personalP1.birthCountry.SSUD": "SOUTH SUDAN",
    "formManifest.personalP1.birthCountry.STBR": "ST. BARTHELEMY",
    "formManifest.personalP1.birthCountry.STCN": "ST. KITTS AND NEVIS",
    "formManifest.personalP1.birthCountry.STM": "SINT MAARTEN",
    "formManifest.personalP1.birthCountry.STPR": "SAO TOME AND PRINCIPE",
    "formManifest.personalP1.birthCountry.STVN": "ST. VINCENT AND THE GRENADINES",
    "formManifest.personalP1.birthCountry.SUD": "SUDAN",
    "formManifest.personalP1.birthCountry.SUDA": "SUDAN",
    "formManifest.personalP1.birthCountry.SUR": "SURINAME",
    "formManifest.personalP1.birthCountry.SURM": "SURINAME",
    "formManifest.personalP1.birthCountry.SVJM": "SVALBARD",
    "formManifest.personalP1.birthCountry.SVK": "SLOVAKIA",
    "formManifest.personalP1.birthCountry.SVN": "SLOVENIA",
    "formManifest.personalP1.birthCountry.SWA": "ESWATINI",
    "formManifest.personalP1.birthCountry.SWDN": "SWEDEN",
    "formManifest.personalP1.birthCountry.SWE": "SWEDEN",
    "formManifest.personalP1.birthCountry.SWI": "SWITZERLAND",
    "formManifest.personalP1.birthCountry.SWTZ": "SWITZERLAND",
    "formManifest.personalP1.birthCountry.SYR": "SYRIA",
    "formManifest.personalP1.birthCountry.SYRI": "SYRIA",
    "formManifest.personalP1.birthCountry.SZLD": "ESWATINI",
    "formManifest.personalP1.birthCountry.TAB": "MEXICO - TABASCO",
    "formManifest.personalP1.birthCountry.TAI": "TAIWAN",
    "formManifest.personalP1.birthCountry.TAJ": "TAJIKISTAN",
    "formManifest.personalP1.birthCountry.TAMP": "MEXICO - TAMAULIPAS",
    "formManifest.personalP1.birthCountry.TAN": "TANZANIA",
    "formManifest.personalP1.birthCountry.TAZN": "TANZANIA",
    "formManifest.personalP1.birthCountry.TCIS": "TURKS AND CAICOS ISLANDS",
    "formManifest.personalP1.birthCountry.TFYR": "MACEDONIA, NORTH",
    "formManifest.personalP1.birthCountry.THA": "THAILAND",
    "formManifest.personalP1.birthCountry.THAI": "THAILAND",
    "formManifest.personalP1.birthCountry.TJK": "TAJIKISTAN",
    "formManifest.personalP1.birthCountry.TKL": "TOKELAU",
    "formManifest.personalP1.birthCountry.TKM": "TURKMENISTAN",
    "formManifest.personalP1.birthCountry.TLAX": "MEXICO - TLAXCALA",
    "formManifest.personalP1.birthCountry.TMOR": "TIMOR-LESTE",
    "formManifest.personalP1.birthCountry.TNSA": "TUNISIA",
    "formManifest.personalP1.birthCountry.TOGO": "TOGO",
    "formManifest.personalP1.birthCountry.TOK": "TOKELAU",
    "formManifest.personalP1.birthCountry.TON": "TONGA",
    "formManifest.personalP1.birthCountry.TONG": "TONGA",
    "formManifest.personalP1.birthCountry.TRIN": "TRINIDAD AND TOBAGO",
    "formManifest.personalP1.birthCountry.TRKY": "TURKEY",
    "formManifest.personalP1.birthCountry.TUCI": "TURKS AND CAICOS ISLANDS",
    "formManifest.personalP1.birthCountry.TUN": "TUNISIA",
    "formManifest.personalP1.birthCountry.TUR": "TURKEY",
    "formManifest.personalP1.birthCountry.TURK": "TURKMENISTAN",
    "formManifest.personalP1.birthCountry.TUV": "TUVALU",
    "formManifest.personalP1.birthCountry.TWAN": "TAIWAN",
    "formManifest.personalP1.birthCountry.UAE": "UNITED ARAB EMIRATES",
    "formManifest.personalP1.birthCountry.UGA": "UGANDA",
    "formManifest.personalP1.birthCountry.UGAN": "UGANDA",
    "formManifest.personalP1.birthCountry.UK": "UNITED KINGDOM",
    "formManifest.personalP1.birthCountry.UKR": "UKRAINE",
    "formManifest.personalP1.birthCountry.URU": "URUGUAY",
    "formManifest.personalP1.birthCountry.US": "UNITED STATES OF AMERICA",
    "formManifest.personalP1.birthCountry.USA": "UNITED STATES OF AMERICA",
    "formManifest.personalP1.birthCountry.USVI": "VIRGIN ISLANDS (U.S.)",
    "formManifest.personalP1.birthCountry.UZB": "UZBEKISTAN",
    "formManifest.personalP1.birthCountry.VAN": "VANUATU",
    "formManifest.personalP1.birthCountry.VANU": "VANUATU",
    "formManifest.personalP1.birthCountry.VAT": "HOLY SEE (VATICAN CITY)",
    "formManifest.personalP1.birthCountry.VEN": "VENEZUELA",
    "formManifest.personalP1.birthCountry.VENZ": "VENEZUELA",
    "formManifest.personalP1.birthCountry.VER": "MEXICO - VERACRUZ",
    "formManifest.personalP1.birthCountry.VI": "VIRGIN ISLANDS (U.S.)",
    "formManifest.personalP1.birthCountry.VIET": "VIETNAM",
    "formManifest.personalP1.birthCountry.VTNM": "VIETNAM",
    "formManifest.personalP1.birthCountry.WAFT": "WALLIS AND FUTUNA ISLANDS",
    "formManifest.personalP1.birthCountry.WAFU": "WALLIS AND FUTUNA ISLANDS",
    "formManifest.personalP1.birthCountry.WESA": "WESTERN SAHARA",
    "formManifest.personalP1.birthCountry.WKI": "WAKE ISLAND",
    "formManifest.personalP1.birthCountry.WSAM": "SAMOA",
    "formManifest.personalP1.birthCountry.XAS": "AT SEA",
    "formManifest.personalP1.birthCountry.XGZ": "GAZA STRIP",
    "formManifest.personalP1.birthCountry.XHI": "HOWLAND ISLAND",
    "formManifest.personalP1.birthCountry.XIR": "IN THE AIR",
    "formManifest.personalP1.birthCountry.XWB": "WEST BANK",
    "formManifest.personalP1.birthCountry.YEM": "YEMEN",
    "formManifest.personalP1.birthCountry.YUC": "MEXICO - YUCATAN",
    "formManifest.personalP1.birthCountry.ZAC": "MEXICO - ZACATECAS",
    "formManifest.personalP1.birthCountry.ZAM": "ZAMBIA",
    "formManifest.personalP1.birthCountry.ZAMB": "ZAMBIA",
    "formManifest.personalP1.birthCountry.ZIM": "ZIMBABWE",
    "formManifest.personalP1.birthCountry.ZIMB": "ZIMBABWE",
    "formManifest.personalP1.birthCountry.help.content": "Select the name that is currently in use for the place where you were born.",
    "formManifest.personalP1.birthCountry.help.title": "Country/Region",
    "formManifest.personalP1.birthCountry.title": "Country/Region of Birth",
    "formManifest.personalP1.birthDate.help.content": "If day or month is unknown, enter as shown in passport.",
    "formManifest.personalP1.birthDate.help.title": "Date of Birth",
    "formManifest.personalP1.birthDate.title": "Date of Birth",
    "formManifest.personalP1.birthState.na.title": "Does Not Apply",
    "formManifest.personalP1.birthState.title": "State/Province of Birth",
    "formManifest.personalP1.gender.help.content": "Please select MALE or FEMALE",
    "formManifest.personalP1.gender.help.title": "Sex",
    "formManifest.personalP1.gender.options.female": "FEMALE",
    "formManifest.personalP1.gender.options.male": "MALE",
    "formManifest.personalP1.gender.title": "Sex",
    "formManifest.personalP1.givenName.help.content": "If your passport does not include a given name, please enter 'FNU' in Given Names.",
    "formManifest.personalP1.givenName.help.title": "Given Names",
    "formManifest.personalP1.givenName.hint": "(e.g., JUAN MIGUEL)",
    "formManifest.personalP1.givenName.title": "Given Names",
    "formManifest.personalP1.hasTelecodeName.help.content":
        "Telecodes are 4 digit code numbers that represent characters in some non-Roman alphabet names.",
    "formManifest.personalP1.hasTelecodeName.help.title": "Telecode",
    "formManifest.personalP1.hasTelecodeName.subQuestions.yes.help.content":
        "If you only have telecode surnames to enter, enter the same given names as above. Conversely, if you only have telecode given names to enter, enter the same surname as above.",
    "formManifest.personalP1.hasTelecodeName.subQuestions.yes.help.title": "Telecode Name",
    "formManifest.personalP1.hasTelecodeName.subQuestions.yes.telecodeGivenName.title": "Telecode Given Names",
    "formManifest.personalP1.hasTelecodeName.subQuestions.yes.telecodeSurname.title": "Telecode Surnames",
    "formManifest.personalP1.hasTelecodeName.subQuestions.yes.title": "Provide the following information:",
    "formManifest.personalP1.hasTelecodeName.title": "Do you have a telecode that represents your name?",
    "formManifest.personalP1.maritalStatus.options.civilUnion": "CIVIL UNION / DOMESTIC PARTNERSHIP",
    "formManifest.personalP1.maritalStatus.options.commonLaw": "COMMON LAW MARRIAGE",
    "formManifest.personalP1.maritalStatus.options.divorced": "DIVORCED",
    "formManifest.personalP1.maritalStatus.options.married": "MARRIED",
    "formManifest.personalP1.maritalStatus.options.other": "OTHER",
    "formManifest.personalP1.maritalStatus.options.separated": "LEGALLY SEPARATED",
    "formManifest.personalP1.maritalStatus.options.single": "SINGLE",
    "formManifest.personalP1.maritalStatus.options.widowed": "WIDOWED",
    "formManifest.personalP1.maritalStatus.title": "Marital Status",
    "formManifest.personalP1.nativeFullName.help.content":
        "If your passport does not include a given name, please enter 'FNU' in Given Names.",
    "formManifest.personalP1.nativeFullName.help.title": "Full Name in Native Alphabet",
    "formManifest.personalP1.nativeFullName.na.title": "Does Not Apply/Technology Not Available",
    "formManifest.personalP1.nativeFullName.title": "Full Name in Native Alphabet",
    "formManifest.personalP1.surname.help.content":
        "Enter all surnames as listed in your passport. If only one name is listed in your passport, enter that Surname.",
    "formManifest.personalP1.surname.help.title": "Surnames",
    "formManifest.personalP1.surname.hint": "(e.g., FERNANDEZ GARCIA)",
    "formManifest.personalP1.surname.title": "Surname",
    "formManifest.personalP1.usedOtherNames.help.content":
        "Other names used include your maiden name, religious name, professional name, or any other names which you are known by or have been known by in the past.",
    "formManifest.personalP1.usedOtherNames.help.title": "Other Names",
    "formManifest.personalP1.usedOtherNames.subQuestions.yes.help.content":
        "If you only have other surnames to enter, enter the same given names as above. Conversely, if you only have other given names to enter, enter the same surname as above.",
    "formManifest.personalP1.usedOtherNames.subQuestions.yes.help.title": "Other Names",
    "formManifest.personalP1.usedOtherNames.subQuestions.yes.otherGivenNames.title": "Other Given Names Used",
    "formManifest.personalP1.usedOtherNames.subQuestions.yes.otherSurnames.title":
        "Other Surnames Used (maiden, religious, professional, aliases, etc.)",
    "formManifest.personalP1.usedOtherNames.subQuestions.yes.title": "Provide the following information:",
    "formManifest.personalP1.usedOtherNames.title": "Have you ever used other names (i.e., maiden, religious, professional, alias, etc.)?",
    "formManifest.personalP2.nationalId.help.content":
        "Your National ID Number is a unique number that your government provides. The U.S. Government provides unique numbers to those who seek employment (Social Security Number) or pay taxes (Taxpayer ID).",
    "formManifest.personalP2.nationalId.help.title": "Identification Numbers",
    "formManifest.personalP2.nationalId.na.title": "Does Not Apply",
    "formManifest.personalP2.nationalId.title": "National Identification Number",
    "formManifest.personalP2.nationality.title": "Country/Region of Origin (Nationality)",
    "formManifest.personalP2.originCountry.AFGH": "AFGHANISTAN",
    "formManifest.personalP2.originCountry.AGS": "MEXICO - AGUASCALIENTES",
    "formManifest.personalP2.originCountry.ALB": "ALBANIA",
    "formManifest.personalP2.originCountry.ALGR": "ALGERIA",
    "formManifest.personalP2.originCountry.ANDO": "ANDORRA",
    "formManifest.personalP2.originCountry.ANGL": "ANGOLA",
    "formManifest.personalP2.originCountry.ANGU": "ANGUILLA",
    "formManifest.personalP2.originCountry.ANTI": "ANTIGUA AND BARBUDA",
    "formManifest.personalP2.originCountry.ARB": "ARUBA",
    "formManifest.personalP2.originCountry.ARG": "ARGENTINA",
    "formManifest.personalP2.originCountry.ARM": "ARMENIA",
    "formManifest.personalP2.originCountry.ASMO": "AMERICAN SAMOA",
    "formManifest.personalP2.originCountry.ASTL": "AUSTRALIA",
    "formManifest.personalP2.originCountry.AUST": "AUSTRIA",
    "formManifest.personalP2.originCountry.AZR": "AZERBAIJAN",
    "formManifest.personalP2.originCountry.BAHR": "BAHRAIN",
    "formManifest.personalP2.originCountry.BAMA": "BAHAMAS",
    "formManifest.personalP2.originCountry.BANG": "BANGLADESH",
    "formManifest.personalP2.originCountry.BC": "MEXICO - BAJA CALIFORNIA NORTE",
    "formManifest.personalP2.originCountry.BCSR": "MEXICO - BAJA CALIFORNIA SUR",
    "formManifest.personalP2.originCountry.BELG": "BELGIUM",
    "formManifest.personalP2.originCountry.BENN": "BENIN",
    "formManifest.personalP2.originCountry.BERM": "BERMUDA",
    "formManifest.personalP2.originCountry.BHU": "BHUTAN",
    "formManifest.personalP2.originCountry.BIH": "BOSNIA-HERZEGOVINA",
    "formManifest.personalP2.originCountry.BLZ": "BELIZE",
    "formManifest.personalP2.originCountry.BOL": "BOLIVIA",
    "formManifest.personalP2.originCountry.BON": "BONAIRE",
    "formManifest.personalP2.originCountry.BOT": "BOTSWANA",
    "formManifest.personalP2.originCountry.BRDO": "BARBADOS",
    "formManifest.personalP2.originCountry.BRND": "BURUNDI",
    "formManifest.personalP2.originCountry.BRNI": "BRUNEI",
    "formManifest.personalP2.originCountry.BRZL": "BRAZIL",
    "formManifest.personalP2.originCountry.BULG": "BULGARIA",
    "formManifest.personalP2.originCountry.BURK": "BURKINA FASO",
    "formManifest.personalP2.originCountry.BURM": "BURMA",
    "formManifest.personalP2.originCountry.BYS": "BELARUS",
    "formManifest.personalP2.originCountry.CAFR": "CENTRAL AFRICAN REPUBLIC",
    "formManifest.personalP2.originCountry.CAMP": "MEXICO - CAMPECHE",
    "formManifest.personalP2.originCountry.CAN": "CANADA",
    "formManifest.personalP2.originCountry.CAVI": "CABO VERDE",
    "formManifest.personalP2.originCountry.CAYI": "CAYMAN ISLANDS",
    "formManifest.personalP2.originCountry.CBDA": "CAMBODIA",
    "formManifest.personalP2.originCountry.CHAD": "CHAD",
    "formManifest.personalP2.originCountry.CHIH": "MEXICO - CHIHUAHUA",
    "formManifest.personalP2.originCountry.CHIL": "CHILE",
    "formManifest.personalP2.originCountry.CHIN": "CHINA",
    "formManifest.personalP2.originCountry.CHIS": "MEXICO - CHIAPAS",
    "formManifest.personalP2.originCountry.CHRI": "CHRISTMAS ISLAND",
    "formManifest.personalP2.originCountry.CKIS": "COOK ISLANDS",
    "formManifest.personalP2.originCountry.CMRN": "CAMEROON",
    "formManifest.personalP2.originCountry.COAH": "MEXICO - COAHUILA",
    "formManifest.personalP2.originCountry.COCI": "COCOS KEELING ISLANDS",
    "formManifest.personalP2.originCountry.COD": "CONGO, DEMOCRATIC REPUBLIC OF THE",
    "formManifest.personalP2.originCountry.CODI": "COTE D`IVOIRE",
    "formManifest.personalP2.originCountry.COIS": "COOK ISLANDS",
    "formManifest.personalP2.originCountry.COL": "COLOMBIA",
    "formManifest.personalP2.originCountry.COLI": "MEXICO - COLIMA",
    "formManifest.personalP2.originCountry.COMO": "COMOROS",
    "formManifest.personalP2.originCountry.CONB": "CONGO, REPUBLIC OF THE",
    "formManifest.personalP2.originCountry.CORI": "COSTA RICA",
    "formManifest.personalP2.originCountry.CROA": "CROATIA",
    "formManifest.personalP2.originCountry.CSTR": "COSTA RICA",
    "formManifest.personalP2.originCountry.CUBA": "CUBA",
    "formManifest.personalP2.originCountry.CUR": "CURACAO",
    "formManifest.personalP2.originCountry.CURA": "CURACAO",
    "formManifest.personalP2.originCountry.CYP": "CYPRUS",
    "formManifest.personalP2.originCountry.CYPR": "CYPRUS",
    "formManifest.personalP2.originCountry.CZEC": "CZECH REPUBLIC",
    "formManifest.personalP2.originCountry.DEN": "DENMARK",
    "formManifest.personalP2.originCountry.DF": "MEXICO - DISTRITO FEDERAL",
    "formManifest.personalP2.originCountry.DGO": "MEXICO - DURANGO",
    "formManifest.personalP2.originCountry.DJI": "DJIBOUTI",
    "formManifest.personalP2.originCountry.DJIB": "DJIBOUTI",
    "formManifest.personalP2.originCountry.DOMA": "DOMINICA",
    "formManifest.personalP2.originCountry.DOMN": "DOMINICA",
    "formManifest.personalP2.originCountry.DOMR": "DOMINICAN REPUBLIC",
    "formManifest.personalP2.originCountry.DROC": "CONGO, DEMOCRATIC REPUBLIC OF THE",
    "formManifest.personalP2.originCountry.EATI": "TIMOR-LESTE",
    "formManifest.personalP2.originCountry.ECU": "ECUADOR",
    "formManifest.personalP2.originCountry.ECUA": "ECUADOR",
    "formManifest.personalP2.originCountry.EGN": "EQUATORIAL GUINEA",
    "formManifest.personalP2.originCountry.EGY": "EGYPT",
    "formManifest.personalP2.originCountry.EGYP": "EGYPT",
    "formManifest.personalP2.originCountry.ELSA": "EL SALVADOR",
    "formManifest.personalP2.originCountry.ELSL": "EL SALVADOR",
    "formManifest.personalP2.originCountry.EQUG": "EQUATORIAL GUINEA",
    "formManifest.personalP2.originCountry.ERI": "ERITREA",
    "formManifest.personalP2.originCountry.ERIT": "ERITREA",
    "formManifest.personalP2.originCountry.EST": "ESTONIA",
    "formManifest.personalP2.originCountry.ETH": "ETHIOPIA",
    "formManifest.personalP2.originCountry.FALI": "FALKLAND ISLANDS",
    "formManifest.personalP2.originCountry.FARI": "FAROE ISLANDS",
    "formManifest.personalP2.originCountry.FIJI": "FIJI",
    "formManifest.personalP2.originCountry.FIN": "FINLAND",
    "formManifest.personalP2.originCountry.FKLI": "FALKLAND ISLANDS",
    "formManifest.personalP2.originCountry.FPOL": "FRENCH POLYNESIA",
    "formManifest.personalP2.originCountry.FR": "FRANCE",
    "formManifest.personalP2.originCountry.FRAN": "FRANCE",
    "formManifest.personalP2.originCountry.FRGU": "FRENCH GUIANA",
    "formManifest.personalP2.originCountry.FRO": "FAROE ISLANDS",
    "formManifest.personalP2.originCountry.FRPO": "FRENCH POLYNESIA",
    "formManifest.personalP2.originCountry.FRST": "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES",
    "formManifest.personalP2.originCountry.FSAT": "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES",
    "formManifest.personalP2.originCountry.FSM": "MICRONESIA",
    "formManifest.personalP2.originCountry.GAB": "GABON",
    "formManifest.personalP2.originCountry.GABN": "GABON",
    "formManifest.personalP2.originCountry.GAM": "GAMBIA, THE",
    "formManifest.personalP2.originCountry.GEO": "GEORGIA",
    "formManifest.personalP2.originCountry.GEOR": "GEORGIA",
    "formManifest.personalP2.originCountry.GER": "GERMANY",
    "formManifest.personalP2.originCountry.GHA": "GHANA",
    "formManifest.personalP2.originCountry.GHAN": "GHANA",
    "formManifest.personalP2.originCountry.GIB": "GIBRALTAR",
    "formManifest.personalP2.originCountry.GNEA": "GUINEA",
    "formManifest.personalP2.originCountry.GRBR": "UNITED KINGDOM",
    "formManifest.personalP2.originCountry.GRC": "GREECE",
    "formManifest.personalP2.originCountry.GREN": "GRENADA",
    "formManifest.personalP2.originCountry.GRLD": "GREENLAND",
    "formManifest.personalP2.originCountry.GRO": "MEXICO - GUERRERO",
    "formManifest.personalP2.originCountry.GTO": "MEXICO - GUANAJUATO",
    "formManifest.personalP2.originCountry.GUAD": "GUADELOUPE",
    "formManifest.personalP2.originCountry.GUAM": "GUAM",
    "formManifest.personalP2.originCountry.GUAT": "GUATEMALA",
    "formManifest.personalP2.originCountry.GUI": "GUINEA",
    "formManifest.personalP2.originCountry.GUIB": "GUINEA - BISSAU",
    "formManifest.personalP2.originCountry.GUY": "GUYANA",
    "formManifest.personalP2.originCountry.HAI": "HAITI",
    "formManifest.personalP2.originCountry.HAT": "HAITI",
    "formManifest.personalP2.originCountry.HEMI": "HEARD AND MCDONALD ISLANDS",
    "formManifest.personalP2.originCountry.HGO": "MEXICO - HIDALGO",
    "formManifest.personalP2.originCountry.HMD": "HEARD AND MCDONALD ISLANDS",
    "formManifest.personalP2.originCountry.HNK": "HONG KONG SAR",
    "formManifest.personalP2.originCountry.HOKO": "HONG KONG BNO",
    "formManifest.personalP2.originCountry.HON": "HONDURAS",
    "formManifest.personalP2.originCountry.HOND": "HONDURAS",
    "formManifest.personalP2.originCountry.HOSE": "HOLY SEE (VATICAN CITY)",
    "formManifest.personalP2.originCountry.HRV": "CROATIA",
    "formManifest.personalP2.originCountry.HUN": "HUNGARY",
    "formManifest.personalP2.originCountry.HUNG": "HUNGARY",
    "formManifest.personalP2.originCountry.ICE": "ICELAND",
    "formManifest.personalP2.originCountry.ICLD": "ICELAND",
    "formManifest.personalP2.originCountry.IDSA": "INDONESIA",
    "formManifest.personalP2.originCountry.IND": "INDIA",
    "formManifest.personalP2.originCountry.INDO": "INDONESIA",
    "formManifest.personalP2.originCountry.IOT": "BRITISH INDIAN OCEAN TERRITORY",
    "formManifest.personalP2.originCountry.IRAN": "IRAN",
    "formManifest.personalP2.originCountry.IRAQ": "IRAQ",
    "formManifest.personalP2.originCountry.IRE": "IRELAND",
    "formManifest.personalP2.originCountry.ISR": "ISRAEL",
    "formManifest.personalP2.originCountry.ISRL": "ISRAEL",
    "formManifest.personalP2.originCountry.ITA": "ITALY",
    "formManifest.personalP2.originCountry.ITLY": "ITALY",
    "formManifest.personalP2.originCountry.IVCO": "COTE D`IVOIRE",
    "formManifest.personalP2.originCountry.JAL": "MEXICO - JALISCO",
    "formManifest.personalP2.originCountry.JAM": "JAMAICA",
    "formManifest.personalP2.originCountry.JOR": "JORDAN",
    "formManifest.personalP2.originCountry.JORD": "JORDAN",
    "formManifest.personalP2.originCountry.JPN": "JAPAN",
    "formManifest.personalP2.originCountry.JRSM": "JERUSALEM",
    "formManifest.personalP2.originCountry.KAZ": "KAZAKHSTAN",
    "formManifest.personalP2.originCountry.KEN": "KENYA",
    "formManifest.personalP2.originCountry.KENY": "KENYA",
    "formManifest.personalP2.originCountry.KGZ": "KYRGYZSTAN",
    "formManifest.personalP2.originCountry.KIR": "KIRIBATI",
    "formManifest.personalP2.originCountry.KIRI": "KIRIBATI",
    "formManifest.personalP2.originCountry.KOR": "KOREA, REPUBLIC OF (SOUTH)",
    "formManifest.personalP2.originCountry.KSV": "KOSOVO",
    "formManifest.personalP2.originCountry.KUW": "KUWAIT",
    "formManifest.personalP2.originCountry.KUWT": "KUWAIT",
    "formManifest.personalP2.originCountry.KYR": "KYRGYZSTAN",
    "formManifest.personalP2.originCountry.LAO": "LAOS",
    "formManifest.personalP2.originCountry.LAOS": "LAOS",
    "formManifest.personalP2.originCountry.LAT": "LATVIA",
    "formManifest.personalP2.originCountry.LATV": "LATVIA",
    "formManifest.personalP2.originCountry.LBYA": "LIBYA",
    "formManifest.personalP2.originCountry.LCHT": "LIECHTENSTEIN",
    "formManifest.personalP2.originCountry.LEB": "LEBANON",
    "formManifest.personalP2.originCountry.LEBN": "LEBANON",
    "formManifest.personalP2.originCountry.LES": "LESOTHO",
    "formManifest.personalP2.originCountry.LIB": "LIBERIA",
    "formManifest.personalP2.originCountry.LIBR": "LIBERIA",
    "formManifest.personalP2.originCountry.LIBY": "LIBYA",
    "formManifest.personalP2.originCountry.LIE": "LIECHTENSTEIN",
    "formManifest.personalP2.originCountry.LITH": "LITHUANIA",
    "formManifest.personalP2.originCountry.LUX": "LUXEMBOURG",
    "formManifest.personalP2.originCountry.LXM": "LUXEMBOURG",
    "formManifest.personalP2.originCountry.MAC": "MACAU",
    "formManifest.personalP2.originCountry.MAD": "MADAGASCAR",
    "formManifest.personalP2.originCountry.MADG": "MADAGASCAR",
    "formManifest.personalP2.originCountry.MAF": "SAINT MARTIN",
    "formManifest.personalP2.originCountry.MALA": "MALAWI",
    "formManifest.personalP2.originCountry.MALD": "MALDIVES",
    "formManifest.personalP2.originCountry.MALI": "MALI",
    "formManifest.personalP2.originCountry.MALT": "MALTA",
    "formManifest.personalP2.originCountry.MALW": "MALAWI",
    "formManifest.personalP2.originCountry.MALY": "MALAYSIA",
    "formManifest.personalP2.originCountry.MARS": "MARSHALL ISLANDS",
    "formManifest.personalP2.originCountry.MART": "MARTINIQUE",
    "formManifest.personalP2.originCountry.MAUR": "MAURITANIA",
    "formManifest.personalP2.originCountry.MAURI": "MAURITIUS",
    "formManifest.personalP2.originCountry.MAYO": "MAYOTTE",
    "formManifest.personalP2.originCountry.MCH": "MEXICO - MICHOACAN",
    "formManifest.personalP2.originCountry.MDWI": "MIDWAY ISLANDS",
    "formManifest.personalP2.originCountry.MEX": "MEXICO",
    "formManifest.personalP2.originCountry.MICR": "MICRONESIA",
    "formManifest.personalP2.originCountry.MKD": "MACEDONIA, NORTH",
    "formManifest.personalP2.originCountry.MLAS": "MALAYSIA",
    "formManifest.personalP2.originCountry.MLD": "MOLDOVA",
    "formManifest.personalP2.originCountry.MLDI": "MALDEN ISLAND",
    "formManifest.personalP2.originCountry.MLDV": "MALDIVES",
    "formManifest.personalP2.originCountry.MLTA": "MALTA",
    "formManifest.personalP2.originCountry.MNP": "NORTH MARIANA ISLANDS",
    "formManifest.personalP2.originCountry.MOLD": "MOLDOVA",
    "formManifest.personalP2.originCountry.MON": "MONACO",
    "formManifest.personalP2.originCountry.MONG": "MONGOLIA",
    "formManifest.personalP2.originCountry.MONS": "MONTSERRAT",
    "formManifest.personalP2.originCountry.MONT": "MONTSERRAT",
    "formManifest.personalP2.originCountry.MOR": "MEXICO - MORELOS",
    "formManifest.personalP2.originCountry.MORO": "MOROCCO",
    "formManifest.personalP2.originCountry.MOZ": "MOZAMBIQUE",
    "formManifest.personalP2.originCountry.MOZA": "MOZAMBIQUE",
    "formManifest.personalP2.originCountry.MRTS": "MAURITIUS",
    "formManifest.personalP2.originCountry.MTG": "MONTENEGRO",
    "formManifest.personalP2.originCountry.MXCO": "MEXICO - STATE OF MEXICO",
    "formManifest.personalP2.originCountry.MYA": "BURMA",
    "formManifest.personalP2.originCountry.MYT": "MAYOTTE",
    "formManifest.personalP2.originCountry.NAM": "NAMIBIA",
    "formManifest.personalP2.originCountry.NAMB": "NAMIBIA",
    "formManifest.personalP2.originCountry.NAU": "NAURU",
    "formManifest.personalP2.originCountry.NAUR": "NAURU",
    "formManifest.personalP2.originCountry.NAY": "MEXICO - NAYARIT",
    "formManifest.personalP2.originCountry.NCAL": "NEW CALEDONIA",
    "formManifest.personalP2.originCountry.NECA": "NEW CALEDONIA",
    "formManifest.personalP2.originCountry.NEP": "NEPAL",
    "formManifest.personalP2.originCountry.NETH": "NETHERLANDS",
    "formManifest.personalP2.originCountry.NFK": "NORFOLK ISLAND",
    "formManifest.personalP2.originCountry.NIC": "NICARAGUA",
    "formManifest.personalP2.originCountry.NIGE": "NIGERIA",
    "formManifest.personalP2.originCountry.NIGR": "NIGER",
    "formManifest.personalP2.originCountry.NIR": "NIGER",
    "formManifest.personalP2.originCountry.NIRE": "NORTHERN IRELAND",
    "formManifest.personalP2.originCountry.NIUE": "NIUE",
    "formManifest.personalP2.originCountry.NKOR": "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)",
    "formManifest.personalP2.originCountry.NL": "MEXICO - NUEVO LEON",
    "formManifest.personalP2.originCountry.NMAI": "NORTH MARIANA ISLANDS",
    "formManifest.personalP2.originCountry.NOR": "NORWAY",
    "formManifest.personalP2.originCountry.NORI": "NORFOLK ISLAND",
    "formManifest.personalP2.originCountry.NORW": "NORWAY",
    "formManifest.personalP2.originCountry.NRA": "NIGERIA",
    "formManifest.personalP2.originCountry.NZEA": "NEW ZEALAND",
    "formManifest.personalP2.originCountry.NZLD": "NEW ZEALAND",
    "formManifest.personalP2.originCountry.OAX": "MEXICO - OAXACA",
    "formManifest.personalP2.originCountry.OMAN": "OMAN",
    "formManifest.personalP2.originCountry.PAK": "PAKISTAN",
    "formManifest.personalP2.originCountry.PALA": "PALAU",
    "formManifest.personalP2.originCountry.PAN": "PANAMA",
    "formManifest.personalP2.originCountry.PAPN": "PAPUA NEW GUINEA",
    "formManifest.personalP2.originCountry.PAR": "PARAGUAY",
    "formManifest.personalP2.originCountry.PARA": "PARAGUAY",
    "formManifest.personalP2.originCountry.PERU": "PERU",
    "formManifest.personalP2.originCountry.PHIL": "PHILIPPINES",
    "formManifest.personalP2.originCountry.PITC": "PITCAIRN ISLANDS",
    "formManifest.personalP2.originCountry.PKST": "PAKISTAN",
    "formManifest.personalP2.originCountry.PLMR": "PALMYRA ATOLL",
    "formManifest.personalP2.originCountry.PNG": "PAPUA NEW GUINEA",
    "formManifest.personalP2.originCountry.POL": "POLAND",
    "formManifest.personalP2.originCountry.PORT": "PORTUGAL",
    "formManifest.personalP2.originCountry.PR": "PUERTO RICO",
    "formManifest.personalP2.originCountry.PRK": "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)",
    "formManifest.personalP2.originCountry.PUE": "MEXICO - PUEBLA",
    "formManifest.personalP2.originCountry.PUER": "PUERTO RICO",
    "formManifest.personalP2.originCountry.QAT": "QATAR",
    "formManifest.personalP2.originCountry.QRO": "MEXICO - QUERETARO",
    "formManifest.personalP2.originCountry.QROO": "MEXICO - QUINTANA ROO",
    "formManifest.personalP2.originCountry.QTAR": "QATAR",
    "formManifest.personalP2.originCountry.RCON": "CONGO, REPUBLIC OF THE",
    "formManifest.personalP2.originCountry.REU": "REUNION",
    "formManifest.personalP2.originCountry.RMI": "MARSHALL ISLANDS",
    "formManifest.personalP2.originCountry.ROM": "ROMANIA",
    "formManifest.personalP2.originCountry.RUS": "RUSSIA",
    "formManifest.personalP2.originCountry.RWA": "RWANDA",
    "formManifest.personalP2.originCountry.RWND": "RWANDA",
    "formManifest.personalP2.originCountry.SAFR": "SOUTH AFRICA",
    "formManifest.personalP2.originCountry.SAHE": "ST. HELENA",
    "formManifest.personalP2.originCountry.SAKN": "ST. KITTS AND NEVIS",
    "formManifest.personalP2.originCountry.SALU": "ST. LUCIA",
    "formManifest.personalP2.originCountry.SAM": "SAMOA",
    "formManifest.personalP2.originCountry.SAMA": "SAINT MARTIN",
    "formManifest.personalP2.originCountry.SANM": "SAN MARINO",
    "formManifest.personalP2.originCountry.SAPM": "ST. PIERRE AND MIQUELON",
    "formManifest.personalP2.originCountry.SARB": "SAUDI ARABIA",
    "formManifest.personalP2.originCountry.SATP": "SAO TOME AND PRINCIPE",
    "formManifest.personalP2.originCountry.SAUD": "SAUDI ARABIA",
    "formManifest.personalP2.originCountry.SAVG": "ST. VINCENT AND THE GRENADINES",
    "formManifest.personalP2.originCountry.SBA": "SERBIA",
    "formManifest.personalP2.originCountry.SEN": "SENEGAL",
    "formManifest.personalP2.originCountry.SENG": "SENEGAL",
    "formManifest.personalP2.originCountry.SERB": "SERBIA",
    "formManifest.personalP2.originCountry.SEYC": "SEYCHELLES",
    "formManifest.personalP2.originCountry.SGS": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND",
    "formManifest.personalP2.originCountry.SGSS": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND",
    "formManifest.personalP2.originCountry.SHEL": "ST. HELENA",
    "formManifest.personalP2.originCountry.SILE": "SIERRA LEONE",
    "formManifest.personalP2.originCountry.SIN": "MEXICO - SINALOA",
    "formManifest.personalP2.originCountry.SING": "SINGAPORE",
    "formManifest.personalP2.originCountry.SINM": "SINT MAARTEN",
    "formManifest.personalP2.originCountry.SJM": "SVALBARD",
    "formManifest.personalP2.originCountry.SKOR": "KOREA, REPUBLIC OF (SOUTH)",
    "formManifest.personalP2.originCountry.SLCA": "ST. LUCIA",
    "formManifest.personalP2.originCountry.SLEO": "SIERRA LEONE",
    "formManifest.personalP2.originCountry.SLMN": "SOLOMON ISLANDS",
    "formManifest.personalP2.originCountry.SLP": "MEXICO - SAN LUIS POTOSI",
    "formManifest.personalP2.originCountry.SLVK": "SLOVAKIA",
    "formManifest.personalP2.originCountry.SLVN": "SLOVENIA",
    "formManifest.personalP2.originCountry.SMAR": "SAN MARINO",
    "formManifest.personalP2.originCountry.SOAF": "SOUTH AFRICA",
    "formManifest.personalP2.originCountry.SOLI": "SOLOMON ISLANDS",
    "formManifest.personalP2.originCountry.SOM": "SOMALIA",
    "formManifest.personalP2.originCountry.SOMA": "SOMALIA",
    "formManifest.personalP2.originCountry.SON": "MEXICO - SONORA",
    "formManifest.personalP2.originCountry.SPA": "SPAIN",
    "formManifest.personalP2.originCountry.SPMI": "ST. PIERRE AND MIQUELON",
    "formManifest.personalP2.originCountry.SPN": "SPAIN",
    "formManifest.personalP2.originCountry.SRIL": "SRI LANKA",
    "formManifest.personalP2.originCountry.SRL": "SRI LANKA",
    "formManifest.personalP2.originCountry.SSDN": "SOUTH SUDAN",
    "formManifest.personalP2.originCountry.SSUD": "SOUTH SUDAN",
    "formManifest.personalP2.originCountry.STBR": "ST. BARTHELEMY",
    "formManifest.personalP2.originCountry.STCN": "ST. KITTS AND NEVIS",
    "formManifest.personalP2.originCountry.STLS": "STATELESS",
    "formManifest.personalP2.originCountry.STM": "SINT MAARTEN",
    "formManifest.personalP2.originCountry.STPR": "SAO TOME AND PRINCIPE",
    "formManifest.personalP2.originCountry.STVN": "ST. VINCENT AND THE GRENADINES",
    "formManifest.personalP2.originCountry.SUD": "SUDAN",
    "formManifest.personalP2.originCountry.SUDA": "SUDAN",
    "formManifest.personalP2.originCountry.SUR": "SURINAME",
    "formManifest.personalP2.originCountry.SURM": "SURINAME",
    "formManifest.personalP2.originCountry.SVJM": "SVALBARD",
    "formManifest.personalP2.originCountry.SVK": "SLOVAKIA",
    "formManifest.personalP2.originCountry.SVN": "SLOVENIA",
    "formManifest.personalP2.originCountry.SWA": "ESWATINI",
    "formManifest.personalP2.originCountry.SWDN": "SWEDEN",
    "formManifest.personalP2.originCountry.SWE": "SWEDEN",
    "formManifest.personalP2.originCountry.SWI": "SWITZERLAND",
    "formManifest.personalP2.originCountry.SWTZ": "SWITZERLAND",
    "formManifest.personalP2.originCountry.SYR": "SYRIA",
    "formManifest.personalP2.originCountry.SYRI": "SYRIA",
    "formManifest.personalP2.originCountry.SZLD": "ESWATINI",
    "formManifest.personalP2.originCountry.TAB": "MEXICO - TABASCO",
    "formManifest.personalP2.originCountry.TAI": "TAIWAN",
    "formManifest.personalP2.originCountry.TAJ": "TAJIKISTAN",
    "formManifest.personalP2.originCountry.TAMP": "MEXICO - TAMAULIPAS",
    "formManifest.personalP2.originCountry.TAN": "TANZANIA",
    "formManifest.personalP2.originCountry.TAZN": "TANZANIA",
    "formManifest.personalP2.originCountry.TCIS": "TURKS AND CAICOS ISLANDS",
    "formManifest.personalP2.originCountry.TFYR": "MACEDONIA, NORTH",
    "formManifest.personalP2.originCountry.THA": "THAILAND",
    "formManifest.personalP2.originCountry.THAI": "THAILAND",
    "formManifest.personalP2.originCountry.TJK": "TAJIKISTAN",
    "formManifest.personalP2.originCountry.TKL": "TOKELAU",
    "formManifest.personalP2.originCountry.TKM": "TURKMENISTAN",
    "formManifest.personalP2.originCountry.TLAX": "MEXICO - TLAXCALA",
    "formManifest.personalP2.originCountry.TMOR": "TIMOR-LESTE",
    "formManifest.personalP2.originCountry.TNSA": "TUNISIA",
    "formManifest.personalP2.originCountry.TOGO": "TOGO",
    "formManifest.personalP2.originCountry.TOK": "TOKELAU",
    "formManifest.personalP2.originCountry.TON": "TONGA",
    "formManifest.personalP2.originCountry.TONG": "TONGA",
    "formManifest.personalP2.originCountry.TRIN": "TRINIDAD AND TOBAGO",
    "formManifest.personalP2.originCountry.TRKY": "TURKEY",
    "formManifest.personalP2.originCountry.TUCI": "TURKS AND CAICOS ISLANDS",
    "formManifest.personalP2.originCountry.TUN": "TUNISIA",
    "formManifest.personalP2.originCountry.TUR": "TURKEY",
    "formManifest.personalP2.originCountry.TURK": "TURKMENISTAN",
    "formManifest.personalP2.originCountry.TUV": "TUVALU",
    "formManifest.personalP2.originCountry.TWAN": "TAIWAN",
    "formManifest.personalP2.originCountry.UAE": "UNITED ARAB EMIRATES",
    "formManifest.personalP2.originCountry.UGA": "UGANDA",
    "formManifest.personalP2.originCountry.UGAN": "UGANDA",
    "formManifest.personalP2.originCountry.UK": "UNITED KINGDOM",
    "formManifest.personalP2.originCountry.UKR": "UKRAINE",
    "formManifest.personalP2.originCountry.URU": "URUGUAY",
    "formManifest.personalP2.originCountry.US": "UNITED STATES OF AMERICA",
    "formManifest.personalP2.originCountry.USA": "UNITED STATES OF AMERICA",
    "formManifest.personalP2.originCountry.USVI": "VIRGIN ISLANDS (U.S.)",
    "formManifest.personalP2.originCountry.UZB": "UZBEKISTAN",
    "formManifest.personalP2.originCountry.VAN": "VANUATU",
    "formManifest.personalP2.originCountry.VANU": "VANUATU",
    "formManifest.personalP2.originCountry.VAT": "HOLY SEE (VATICAN CITY)",
    "formManifest.personalP2.originCountry.VEN": "VENEZUELA",
    "formManifest.personalP2.originCountry.VENZ": "VENEZUELA",
    "formManifest.personalP2.originCountry.VER": "MEXICO - VERACRUZ",
    "formManifest.personalP2.originCountry.VIET": "VIETNAM",
    "formManifest.personalP2.originCountry.VTNM": "VIETNAM",
    "formManifest.personalP2.originCountry.WAFT": "WALLIS AND FUTUNA ISLANDS",
    "formManifest.personalP2.originCountry.WAFU": "WALLIS AND FUTUNA ISLANDS",
    "formManifest.personalP2.originCountry.WESA": "WESTERN SAHARA",
    "formManifest.personalP2.originCountry.WSAM": "SAMOA",
    "formManifest.personalP2.originCountry.XAS": "AT SEA",
    "formManifest.personalP2.originCountry.XGZ": "GAZA STRIP",
    "formManifest.personalP2.originCountry.XHI": "HOWLAND ISLAND",
    "formManifest.personalP2.originCountry.XIR": "IN THE AIR",
    "formManifest.personalP2.originCountry.YEM": "YEMEN",
    "formManifest.personalP2.originCountry.YUC": "MEXICO - YUCATAN",
    "formManifest.personalP2.originCountry.ZAC": "MEXICO - ZACATECAS",
    "formManifest.personalP2.originCountry.ZAM": "ZAMBIA",
    "formManifest.personalP2.originCountry.ZAMB": "ZAMBIA",
    "formManifest.personalP2.originCountry.ZIM": "ZIMBABWE",
    "formManifest.personalP2.originCountry.ZIMB": "ZIMBABWE",
    "formManifest.personalP2.otherPermanentResidencies.help.content":
        "Permanent resident means any individual who has been legally granted by a country/region permission to live and work without time limitation in that country/region.",
    "formManifest.personalP2.otherPermanentResidencies.help.title": "Permanent Resident",
    "formManifest.personalP2.otherPermanentResidencies.subQuestions.yes.permanentResidentCountry.title":
        "Country/Region of Permanent Residence",
    "formManifest.personalP2.otherPermanentResidencies.subQuestions.yes.title": "Other Permanent Resident Country/Region",
    "formManifest.personalP2.otherPermanentResidencies.title":
        "Are you a permanent resident of a country/region other than your country/region of origin (nationality) indicated above?",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.otherNationality.help.content":
        "Enter all nationalities you currently hold and all nationalities you have previously held, regardless of whether you have formally and/or legally relinquished the nationality. If the country where you previously held nationality is no longer a political entity or country, select the nationality that corresponds with the name of the country that is currently used for that location.",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.otherNationality.help.title": "Other Nationalities",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.otherNationality.title": "Other Country/Region of Origin (Nationality)",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.passportNumber.subQuestions.yes.help.content":
        "Enter the passport number exactly as it appears on the passport.",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.passportNumber.subQuestions.yes.help.title": "Passport Number",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.passportNumber.subQuestions.yes.title": "Passport Number",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.passportNumber.title":
        "Do you hold a passport for the other country/region of origin (nationality) above?",
    "formManifest.personalP2.previousNationalities.subQuestions.yes.title": "Other Nationalities",
    "formManifest.personalP2.previousNationalities.title":
        "Do you hold or have you held any nationality other than the one indicated above on nationality?",
    "formManifest.personalP2.usSocialSecurityNumber.na.title": "Does Not Apply",
    "formManifest.personalP2.usSocialSecurityNumber.title": "U.S. Social Security Number",
    "formManifest.personalP2.usTaxPayerId.na.title": "Does Not Apply",
    "formManifest.personalP2.usTaxPayerId.title": "U.S. Taxpayer ID Number",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.city.title": "City",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.country.title": "Country / Region",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.dutiesDescription.title": "Briefly describe your duties",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.line1.title": "Street Address (Line 1)",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.line2.title": "Street Address (Line 2)",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.monthlyIncome.na.title": "Does not apply",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.monthlyIncome.title":
        "Monthly Income in Local Currency (if employed)",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.phone.title": "Phone Number",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.startDate.title": "Start Date",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.state.na.title": "Does not apply",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.state.title": "State/Province",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.title": "Present Employer or School Address",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.zipCode.na.title": "Does not apply",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.address.zipCode.title": "Postal Zone / ZIP Code",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.name.title": "Present Employer or School Name",
    "formManifest.presentOccupationPage.presentOccupation.employerInfo.title": "Present Employer or School Information",
    "formManifest.presentOccupationPage.presentOccupation.otherOccupationDetails.title": "Specify other",
    "formManifest.presentOccupationPage.presentOccupation.primaryOccupation.title": "Primary Occupation",
    "formManifest.presentOccupationPage.presentOccupation.title": "Present Work/Education/Training Information",
    "formManifest.previousOccupationPage.education.help.content":
        "You must answer Yes to this question if you have ever attended, for any length of time, a high school/secondary school (or its equivalent in your country) or college, university, graduate school, a doctoral program, or a vocational program.",
    "formManifest.previousOccupationPage.education.help.title": "Level of Education",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.city.title": "City",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.country.title": "Country",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.line1.title": "Street Address (Line 1)",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.line2.title": "Street Address (Line 2)",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.state.na.title": "Does not apply",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.state.title": "State/Province",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.title": "Address",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.zipCode.na.title": "Does not apply",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.address.zipCode.title": "Postal Zone/ZIP Code",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.courseOfStudy.title": "Course of Study",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.endDate.title": "Date of Attendance To",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.name.title": "Name of Institution",
    "formManifest.previousOccupationPage.education.subQuestions.yes.institutions.startDate.title": "Date of Attendance From",
    "formManifest.previousOccupationPage.education.subQuestions.yes.title":
        "Provide the following information on the educational institution(s) you have attended.",
    "formManifest.previousOccupationPage.education.title": "Have you attended any educational institutions at a secondary level or above?",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.city.title": "City/Town",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.country.title": "Country",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.line1.title":
        "Employer Street Address (Line 1)",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.line2.title":
        "Employer Street Address (Line 2)",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.phone.title": "Employer Telephone Number",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.state.na.title": "Does not apply",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.state.title": "State/Province",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.title": "Employer Address",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.zipCode.na.title": "Does not apply",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.address.zipCode.title": "Postal Zone/ZIP Code",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.dutiesDescription.title":
        "Briefly describe your duties",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.endDate.title": "Employment Date To",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.jobTitle.title": "Job Title",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.name.title": "Employer Name",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.startDate.title": "Employment Date From",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.superVisorGivenName.na.title": "Do not know",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.superVisorGivenName.title":
        "Supervisor's Given Names",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.superVisorSurname.na.title": "Do not know",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.employers.superVisorSurname.title": "Supervisor's Surname",
    "formManifest.previousOccupationPage.previousEmployers.subQuestions.yes.title": "Employer/Employment Information:",
    "formManifest.previousOccupationPage.previousEmployers.title": "Were you previously employed?",
    "formManifest.previousUsTravelPage.hasDeniedTravelAuthorization.subQuestions.yes.title":
        "Explain why you were denied travel authorization",
    "formManifest.previousUsTravelPage.hasDeniedTravelAuthorization.title":
        "Have you ever been denied travel authorization by the Department of Homeland Security through the Electronic System for Travel Authorization (ESTA)?",
    "formManifest.previousUsTravelPage.hasImmigrantPetition.subQuestions.yes.title": "Explain the circumstances of the petition",
    "formManifest.previousUsTravelPage.hasImmigrantPetition.title":
        "Has anyone ever filed an immigrant petition on your behalf with the United States Citizenship and Immigration Services?",
    "formManifest.previousUsTravelPage.hasRefusedAdmission.subQuestions.yes.title":
        "Explain why you were refused a visa or admission to the United States, or why you withdrew your application for admission at the port of entry",
    "formManifest.previousUsTravelPage.hasRefusedAdmission.title":
        "Have you ever been refused a U.S. Visa, or been refused admission to the United States, or withdrawn your application for admission at the port of entry?",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.isSameLocation.title":
        "Are you applying in the same country or location where the visa above was issued, and is this country or location your place of principal of residence?",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.isSameVisaType.title": "Are you applying for the same type of visa?",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.issueDate.title": "Date Last Visa Was Issued",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.title": "Previous U.S. Visa",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaCancelledOrRevoked.subQuestions.yes.title":
        "Explain why your visa was cancelled or revoked",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaCancelledOrRevoked.title":
        "Has your U.S. Visa ever been cancelled or revoked?",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaLostOrStolen.subQuestions.yes.lostExplanation.title": "Explain",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaLostOrStolen.subQuestions.yes.lostYear.title":
        "Enter year visa was lost or stolen:",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaLostOrStolen.title": "Has your U.S. Visa ever been lost or stolen?",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaNumber.help.content":
        "Enter the 8-digit number that is displayed in red on the lower right hand side of your visa. If your previous visa was a Border Crossing Card enter the last 12-digit number of the first line of the machine readable zone.",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaNumber.help.title": "Visa Number",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaNumber.na.title": "Do not know",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.visaNumber.title": "Visa Number",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.wasTenPrinted.help.content":
        "Ten-printed means that you have provided fingerprints for all your fingers, as opposed to having provided only two fingerprints.",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.wasTenPrinted.help.title": "Ten-printed",
    "formManifest.previousUsTravelPage.hasUSVisa.subQuestions.yes.wasTenPrinted.title": "Have you been ten-printed?",
    "formManifest.previousUsTravelPage.hasUSVisa.title": "Have you ever been issued a U.S. Visa?",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.hasUsDriverLicense.subQuestions.yes.licenseNumber.na.title":
        "Do not know",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.hasUsDriverLicense.subQuestions.yes.licenseNumber.title":
        "Driver's License Number",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.hasUsDriverLicense.subQuestions.yes.licenseState.title":
        "State of Driver's License",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.hasUsDriverLicense.subQuestions.yes.title":
        "Provide information on your U.S. Driver's Licenses:",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.hasUsDriverLicense.title":
        "Do you or did you ever hold a U.S. Driver's License?",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.help.content":
        "If you are unsure about when you visited the U.S., please provide a best estimate.",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.help.title": "Previous U.S. Visits",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.title": "Details on your visit",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.usVisitDetails.dateArrived.title": "Date Arrived",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.usVisitDetails.stayLength.title": "Length of stay in the us",
    "formManifest.previousUsTravelPage.hasVisitedUS.subQuestions.yes.usVisitDetails.title": "Provide information on your last U.S. visit:",
    "formManifest.previousUsTravelPage.hasVisitedUS.title": "Have you ever been in the U.S.?",
    "formManifest.securityBackgroundPage1.disease.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage1.disease.title":
        "Do you have a communicable disease of public health significance? (Communicable diseases of public significance include chancroid, gonorrhea, granuloma inguinale, infectious leprosy, lymphogranuloma venereum, infectious stage syphilis, active tuberculosis, and other diseases as determined by the Department of Health and Human Services.)",
    "formManifest.securityBackgroundPage1.disorder.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage1.disorder.title":
        "Do you have a mental or physical disorder that poses or is likely to pose a threat to the safety or welfare of yourself or others?",
    "formManifest.securityBackgroundPage1.drugAbuser.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage1.drugAbuser.title": "Are you or have you ever been a drug abuser or addict?",
    "formManifest.securityBackgroundPage2.arrested.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.arrested.title":
        "Have you ever been arrested or convicted for any offense or crime, even though subject of a pardon, amnesty, or other similar action?",
    "formManifest.securityBackgroundPage2.assistedSevereTrafficking.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.assistedSevereTrafficking.title":
        "Have you ever knowingly aided, abetted, assisted or colluded with an individual who has committed, or conspired to commit a severe human trafficking offense in the United States or outside the United States?",
    "formManifest.securityBackgroundPage2.controlledSubstance.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.controlledSubstance.title":
        "Have you ever violated, or engaged in a conspiracy to violate, any law relating to controlled substances?",
    "formManifest.securityBackgroundPage2.humanTrafficking.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.humanTrafficking.title":
        "Have you ever committed or conspired to commit a human trafficking offense in the United States or outside the United States?",
    "formManifest.securityBackgroundPage2.moneyLaundry.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.moneyLaundry.title":
        "Have you ever been involved in, or do you seek to engage in, money laundering?",
    "formManifest.securityBackgroundPage2.prostitution.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.prostitution.title":
        "Are you coming to the United States to engage in prostitution or unlawful commercialized vice or have you been engaged in prostitution or procuring prostitutes within the past 10 years?",
    "formManifest.securityBackgroundPage2.traffickingRelated.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage2.traffickingRelated.title":
        "Are you the spouse, son, or daughter of an individual who has committed or conspired to commit a human trafficking offense in the United States or outside the United States and have you within the last five years, knowingly benefited from the trafficking activities?",
    "formManifest.securityBackgroundPage3.childSoldiers.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.childSoldiers.title": "Have you ever engaged in the recruitment or the use of child soldiers?",
    "formManifest.securityBackgroundPage3.coerciveTransplant.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.coerciveTransplant.title":
        "Have you ever been directly involved in the coercive transplantation of human organs or bodily tissue?",
    "formManifest.securityBackgroundPage3.espionage.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.espionage.title":
        "Do you seek to engage in espionage, sabotage, export control violations, or any other illegal activity while in the United States?",
    "formManifest.securityBackgroundPage3.extrajudicialViolence.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.extrajudicialViolence.title":
        "Have you committed, ordered, incited, assisted, or otherwise participated in extrajudicial killings, political killings, or other acts of violence?",
    "formManifest.securityBackgroundPage3.genocide.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.genocide.title":
        "Have you ever ordered, incited, committed, assisted, or otherwise participated in genocide?",
    "formManifest.securityBackgroundPage3.populationControl.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.populationControl.title":
        "Have you ever been directly involved in the establishment or enforcement of population controls forcing a woman to undergo an abortion against her free choice or a man or a woman to undergo sterilization against his or her free will?",
    "formManifest.securityBackgroundPage3.religiousFreedomViolation.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.religiousFreedomViolation.title":
        "Have you, while serving as a government official, been responsible for or directly carried out, at any time, particularly severe violations of religious freedom?",
    "formManifest.securityBackgroundPage3.terroristActivity.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.terroristActivity.title":
        "Do you seek to engage in terrorist activities while in the United States or have you ever engaged in terrorist activities?",
    "formManifest.securityBackgroundPage3.terroristMembership.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.terroristMembership.title": "Are you a member or representative of a terrorist organization?",
    "formManifest.securityBackgroundPage3.terroristRelated.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.terroristRelated.title":
        "Are you the spouse, son, or daughter of an individual who has engaged in terrorist activity, including providing financial assistance or other support to terrorists or terrorist organizations, in the last five years?",
    "formManifest.securityBackgroundPage3.terroristSupport.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.terroristSupport.title":
        "Have you ever or do you intend to provide financial assistance or other support to terrorists or terrorist organizations?",
    "formManifest.securityBackgroundPage3.torture.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage3.torture.title":
        "Have you ever committed, ordered, incited, assisted, or otherwise participated in torture?",
    "formManifest.securityBackgroundPage4.deported.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage4.deported.title": "Have you ever been removed or deported from any country?",
    "formManifest.securityBackgroundPage4.failedHearing.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage4.failedHearing.title":
        "Have you failed to attend a hearing on removability or inadmissibility within the last five years?",
    "formManifest.securityBackgroundPage4.immigrationFraud.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage4.immigrationFraud.title":
        "Have you ever sought to obtain or assist others to obtain a visa, entry into the United States, or any other United States immigration benefit by fraud or willful misrepresentation or other unlawful means?",
    "formManifest.securityBackgroundPage4.removalHearing.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage4.removalHearing.title": "Have you ever been the subject of a removal or deportation hearing?",
    "formManifest.securityBackgroundPage4.visaViolation.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage4.visaViolation.title":
        "Have you ever been unlawfully present, overstayed the amount of time granted by an immigration official or otherwise violated the terms of a U.S. visa?",
    "formManifest.securityBackgroundPage5.jVisaRequirement.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage5.jVisaRequirement.title":
        "Are you a former exchange visitor (J) who has not yet fulfilled the two-year foreign residence requirement?",
    "formManifest.securityBackgroundPage5.publicSchoolAttendance.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage5.publicSchoolAttendance.title":
        "Have you attended a public elementary school on student (F) status or a public secondary school after November 30, 1996 without reimbursing the school?",
    "formManifest.securityBackgroundPage5.taxAvoidanceRenunciation.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage5.taxAvoidanceRenunciation.title":
        "Have you ever renounced United States citizenship for the purposes of avoiding taxation?",
    "formManifest.securityBackgroundPage5.unlawfulVoting.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage5.unlawfulVoting.title":
        "Have you voted in the United States in violation of any law or regulation?",
    "formManifest.securityBackgroundPage5.withheldCustody.subQuestions.yes.title": "Explain",
    "formManifest.securityBackgroundPage5.withheldCustody.title":
        "Have you ever withheld custody of a U.S. citizen child outside the United States from a person granted legal custody by a U.S. court?",
    "formManifest.spouseInfoPage.addressType.title": "Type of Address Where Spouse Lives",
    "formManifest.spouseInfoPage.birth.city.na.title": "Do not know",
    "formManifest.spouseInfoPage.birth.city.title": "City",
    "formManifest.spouseInfoPage.birth.country.title": "Country",
    "formManifest.spouseInfoPage.birth.title": "Spouse's Place of Birth",
    "formManifest.spouseInfoPage.spouseDOB.title": "Spouse's Date of Birth",
    "formManifest.spouseInfoPage.spouseGivenName.title": "Spouse's Given Name (Including Maiden Name)",
    "formManifest.spouseInfoPage.spouseOriginCountry.title": "Spouse's Country/Region of Origin",
    "formManifest.spouseInfoPage.spouseSurname.title": "Spouse's Surname",
    "formManifest.studentVisaPage1.contacts.address.city.title": "City",
    "formManifest.studentVisaPage1.contacts.address.country.title": "Country/Region",
    "formManifest.studentVisaPage1.contacts.address.line1.title": "Street Address Line 1",
    "formManifest.studentVisaPage1.contacts.address.line2.title": "Street Address Line 2",
    "formManifest.studentVisaPage1.contacts.address.state.na.title": "Does Not Apply",
    "formManifest.studentVisaPage1.contacts.address.state.title": "State/Province",
    "formManifest.studentVisaPage1.contacts.address.zipCode.na.title": "Does Not Apply",
    "formManifest.studentVisaPage1.contacts.address.zipCode.title": "Postal Zone/ZIP Code",
    "formManifest.studentVisaPage1.contacts.email.na.title": "Does Not Apply",
    "formManifest.studentVisaPage1.contacts.email.title": "Email Address",
    "formManifest.studentVisaPage1.contacts.givenNames.title": "Given Names",
    "formManifest.studentVisaPage1.contacts.phone.na.title": "Does Not Apply",
    "formManifest.studentVisaPage1.contacts.phone.title": "Telephone Number",
    "formManifest.studentVisaPage1.contacts.surnames.title": "Surnames",
    "formManifest.studentVisaPage1.contacts.title": "Additional Point of Contact Information",
    "formManifest.studentVisaPage2.additionalInformation.address.city.title": "City",
    "formManifest.studentVisaPage2.additionalInformation.address.line1.title": "Street Address Line 1",
    "formManifest.studentVisaPage2.additionalInformation.address.line2.title": "Street Address Line 2",
    "formManifest.studentVisaPage2.additionalInformation.address.state.title": "State",
    "formManifest.studentVisaPage2.additionalInformation.address.zipCode.title": "Postal Zone/ZIP Code",
    "formManifest.studentVisaPage2.additionalInformation.courseOfStudy.help.content":
        'For high school course of study please indicate "Academic" or "Vocational." For all other educational levels please indicate your major or concentration',
    "formManifest.studentVisaPage2.additionalInformation.courseOfStudy.help.title": "Course Study",
    "formManifest.studentVisaPage2.additionalInformation.courseOfStudy.title": "Course of Study",
    "formManifest.studentVisaPage2.additionalInformation.schoolName.title": "Name of School",
    "formManifest.studentVisaPage2.additionalInformation.title": "Provide additional information below:",
    "formManifest.studentVisaPage2.sevisId.title": "SEVIS ID",
    "formManifest.temporaryVisaPage.applicationReceiptNumber.title": "Application Receipt/Petition Number",
    "formManifest.temporaryVisaPage.employer.address.city.title": "City",
    "formManifest.temporaryVisaPage.employer.address.line1.title": "U.S. Street Address (Line 1)",
    "formManifest.temporaryVisaPage.employer.address.line2.title": "U.S. Street Address (Line 2)",
    "formManifest.temporaryVisaPage.employer.address.state.title": "State",
    "formManifest.temporaryVisaPage.employer.address.zipCode.title": "ZIP Code (if known)",
    "formManifest.temporaryVisaPage.employer.monthlySalaryUSD.title": "Enter monthly income (in USD)",
    "formManifest.temporaryVisaPage.employer.name.title": "Name of Employer",
    "formManifest.temporaryVisaPage.employer.phone.title": "Phone Number",
    "formManifest.temporaryVisaPage.employer.title": "Where Do You Intend to Work?",
    "formManifest.temporaryVisaPage.nameOfPetitioner.title": "Name of Person/Company who Filed Petition",
    "formManifest.travelCompanionsPage.companions.companionGivenName.title": "Given names of the person traveling with you",
    "formManifest.travelCompanionsPage.companions.companionRelationship.title": "Relationship to you",
    "formManifest.travelCompanionsPage.companions.companionSurname.title": "Surnames of the person traveling with you",
    "formManifest.travelCompanionsPage.companions.title": "Provide the following information for each person traveling with you:",
    "formManifest.travelCompanionsPage.groupName.title": "Enter the name of the group you are traveling with",
    "formManifest.travelCompanionsPage.hasCompanions.help.content":
        "You should answer Yes to this question if you are traveling with family, as part of an organized tour, or as part of a performing group or athletic team. You do not need to list individuals who are traveling with you for the purposes of employment with the same employer.",
    "formManifest.travelCompanionsPage.hasCompanions.help.title": "Traveling with Others",
    "formManifest.travelCompanionsPage.hasCompanions.title": "Are there other persons traveling with you?",
    "formManifest.travelCompanionsPage.isGroupTravel.title": "Are you traveling as part of a group or organization?",
    "formManifest.travelCompanionsPage.relationshipType.businessAssociate": "Business Associate",
    "formManifest.travelCompanionsPage.relationshipType.child": "Child",
    "formManifest.travelCompanionsPage.relationshipType.friend": "Friend",
    "formManifest.travelCompanionsPage.relationshipType.other": "Other",
    "formManifest.travelCompanionsPage.relationshipType.otherRelative": "Other Relative",
    "formManifest.travelCompanionsPage.relationshipType.parent": "Parent",
    "formManifest.travelCompanionsPage.relationshipType.spouse": "Spouse",
    "formManifest.visaPurposePage.addressDetails.city.title": "City",
    "formManifest.visaPurposePage.addressDetails.line1.title": "Address Line 1",
    "formManifest.visaPurposePage.addressDetails.line2.title": "Address Line 2",
    "formManifest.visaPurposePage.addressDetails.state.title": "State",
    "formManifest.visaPurposePage.addressDetails.title": "Address where you will stay in the U.S.",
    "formManifest.visaPurposePage.addressDetails.tripPayer.employerInTheUS": "Employer in the U.S.",
    "formManifest.visaPurposePage.addressDetails.tripPayer.otherCompanyOrganization": "Other Company/Organization",
    "formManifest.visaPurposePage.addressDetails.tripPayer.otherPerson": "Other Person",
    "formManifest.visaPurposePage.addressDetails.tripPayer.presentEmployer": "Present Employer",
    "formManifest.visaPurposePage.addressDetails.tripPayer.self": "Self",
    "formManifest.visaPurposePage.addressDetails.tripPayer.title": "Person/Entity Paying for Your Trip",
    "formManifest.visaPurposePage.addressDetails.zipCode.title": "Zip Code",
    "formManifest.visaPurposePage.intendedTravelPlans.arrivalDate.title": "Arrival Date",
    "formManifest.visaPurposePage.intendedTravelPlans.help.content": "If you are unsure of your travel plans, please provide an estimate.",
    "formManifest.visaPurposePage.intendedTravelPlans.help.title": "Arrival Plans",
    "formManifest.visaPurposePage.intendedTravelPlans.lengthOfStay.title": "Intended length of stay in the U.S.",
    "formManifest.visaPurposePage.intendedTravelPlans.title": "Please provide an explanation of your travel plans.",
    "formManifest.visaPurposePage.lcaNumber.help.content":
        "An LCA Number refers to the Labor Condition Application (LCA) case number, which is issued by the U.S. Department of Labor (DOL) for employers hiring non-immigrant workers under the H-1B, H-1B1, or E-3 visa categories. The LCA is a document employers file to certify that they comply with the terms and conditions of hiring foreign workers, including offering a prevailing wage and ensuring no adverse impact on U.S. workers.",
    "formManifest.visaPurposePage.lcaNumber.help.title": "LCA Number",
    "formManifest.visaPurposePage.lcaNumber.title": "Labor Condition Application (LCA) case number",
    "formManifest.visaPurposePage.lengthOfTimeUnit.day": "Day(s)",
    "formManifest.visaPurposePage.lengthOfTimeUnit.lessThan24Hours": "Less than 24 hours",
    "formManifest.visaPurposePage.lengthOfTimeUnit.month": "Month(s)",
    "formManifest.visaPurposePage.lengthOfTimeUnit.week": "Week(s)",
    "formManifest.visaPurposePage.lengthOfTimeUnit.year": "Year(s)",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.city.title": "City",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.country.title": "Country/Region",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.help.content":
        "Provide the street address, apartment number (if applicable), city, state or province, country, and postal zone (if applicable) of the person or organization that is paying for your travel.",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.help.title": "Payer Address",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.line1.title": "Street Address (Line 1)",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.line2.title": "Street Address (Line 2) *Optional",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.postalCode.na.title": "Does Not Apply",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.postalCode.title": "Postal Zone/ZIP Code",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.stateOrProvince.na.title": "Does Not Apply",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.stateOrProvince.title": "State/Province",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyAddress.title": "Address of Company/Organization Paying for Trip",
    "formManifest.visaPurposePage.otherCompanyTripPayer.companyName.title": "Name of Company/Organization Paying for Trip",
    "formManifest.visaPurposePage.otherCompanyTripPayer.relationshipToYou.title": "Relationship to You",
    "formManifest.visaPurposePage.otherCompanyTripPayer.telephoneNumber.title": "Telephone Number",
    "formManifest.visaPurposePage.otherCompanyTripPayer.title": "Provide the following information:",
    "formManifest.visaPurposePage.otherPersonTripPayer.email.hint": "(e.g., emailaddress@example.com)",
    "formManifest.visaPurposePage.otherPersonTripPayer.email.na.title": "Does Not Apply",
    "formManifest.visaPurposePage.otherPersonTripPayer.email.title": "Email Address",
    "formManifest.visaPurposePage.otherPersonTripPayer.givenNames.hint": "(e.g., JUAN MIGUEL)",
    "formManifest.visaPurposePage.otherPersonTripPayer.givenNames.title": "Given Names of Person Paying for Trip",
    "formManifest.visaPurposePage.otherPersonTripPayer.isSameAddress.title":
        "Is the address of the party paying for your trip the same as your Home or Mailing Address?",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.city.title": "City",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.country.title": "Country/Region",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.line1.title": "Street Address (Line 1)",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.line2.title": "Street Address (Line 2) *Optional",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.postalCode.na.title": "Does Not Apply",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.postalCode.title": "Postal Zone/ZIP Code",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.stateOrProvince.na.title": "Does Not Apply",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.stateOrProvince.title": "State/Province",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerAddress.title": "Address of Person Paying",
    "formManifest.visaPurposePage.otherPersonTripPayer.payerRelationship.title": "Payer relationship to You",
    "formManifest.visaPurposePage.otherPersonTripPayer.surnames.hint": "(e.g., FERNANDEZ GARCIA)",
    "formManifest.visaPurposePage.otherPersonTripPayer.surnames.title": "Surnames of Person Paying for Trip",
    "formManifest.visaPurposePage.otherPersonTripPayer.telephoneNumber.title": "Telephone Number",
    "formManifest.visaPurposePage.otherPersonTripPayer.title": "Provide the following information:",
    "formManifest.visaPurposePage.petitionNumber.help.content":
        "The receipt number is a 13-character alphanumeric identifier and follows this format: XXX-YY-ZZZ-NNNNN",
    "formManifest.visaPurposePage.petitionNumber.help.title": "Petition Number or Application Receipt Number",
    "formManifest.visaPurposePage.petitionNumber.title": "Petition Number or Application Receipt Number",
    "formManifest.visaPurposePage.principalApplicant.givenNames.hint": "(e.g., JUAN MIGUEL)",
    "formManifest.visaPurposePage.principalApplicant.givenNames.title": "Given Names of Principal Applicant",
    "formManifest.visaPurposePage.principalApplicant.j2.help.content":
        "Please provide the name of the J-1 exchange visitor (principal applicant) whose J-2 dependent you are applying as.",
    "formManifest.visaPurposePage.principalApplicant.j2.help.title": "Principal Applicant Information",
    "formManifest.visaPurposePage.principalApplicant.j2.title": "Principal Applicant Information",
    "formManifest.visaPurposePage.principalApplicant.n9.help.content":
        "Please provide the name of the N-8 special immigrant (principal applicant) whose N-9 child you are applying as.",
    "formManifest.visaPurposePage.principalApplicant.n9.help.title": "Principal Applicant Information",
    "formManifest.visaPurposePage.principalApplicant.n9.title": "Principal Applicant Information",
    "formManifest.visaPurposePage.principalApplicant.surnames.hint": "(e.g., FERNANDEZ GARCIA)",
    "formManifest.visaPurposePage.principalApplicant.surnames.title": "Surnames of Principal Applicant",
    "formManifest.visaPurposePage.purposes.purpose.title": "Purpose of Trip to the U.S.",
    "formManifest.visaPurposePage.purposes.title": "Purpose of Visit",
    "formManifest.visaPurposePage.specificTravelPlans.conditionalPrefill.message":
        "Based on your birth country (Mexico), this field has been automatically set to 'No' and cannot be changed.",
    "formManifest.visaPurposePage.specificTravelPlans.title": "Have you made specific travel plans?",
    "formManifest.visaPurposePage.specifyVisa.title": "Specify Visa",
    "formManifest.visaPurposePage.state.alabama": "Alabama",
    "formManifest.visaPurposePage.state.alaska": "Alaska",
    "formManifest.visaPurposePage.state.americanSamoa": "American Samoa",
    "formManifest.visaPurposePage.state.arizona": "Arizona",
    "formManifest.visaPurposePage.state.arkansas": "Arkansas",
    "formManifest.visaPurposePage.state.california": "California",
    "formManifest.visaPurposePage.state.colorado": "Colorado",
    "formManifest.visaPurposePage.state.connecticut": "Connecticut",
    "formManifest.visaPurposePage.state.delaware": "Delaware",
    "formManifest.visaPurposePage.state.districtOfColumbia": "District of Columbia",
    "formManifest.visaPurposePage.state.florida": "Florida",
    "formManifest.visaPurposePage.state.georgia": "Georgia",
    "formManifest.visaPurposePage.state.guam": "Guam",
    "formManifest.visaPurposePage.state.hawaii": "Hawaii",
    "formManifest.visaPurposePage.state.idaho": "Idaho",
    "formManifest.visaPurposePage.state.illinois": "Illinois",
    "formManifest.visaPurposePage.state.indiana": "Indiana",
    "formManifest.visaPurposePage.state.iowa": "Iowa",
    "formManifest.visaPurposePage.state.kansas": "Kansas",
    "formManifest.visaPurposePage.state.kentucky": "Kentucky",
    "formManifest.visaPurposePage.state.louisiana": "Louisiana",
    "formManifest.visaPurposePage.state.maine": "Maine",
    "formManifest.visaPurposePage.state.maryland": "Maryland",
    "formManifest.visaPurposePage.state.massachusetts": "Massachusetts",
    "formManifest.visaPurposePage.state.michigan": "Michigan",
    "formManifest.visaPurposePage.state.minnesota": "Minnesota",
    "formManifest.visaPurposePage.state.mississippi": "Mississippi",
    "formManifest.visaPurposePage.state.missouri": "Missouri",
    "formManifest.visaPurposePage.state.montana": "Montana",
    "formManifest.visaPurposePage.state.nebraska": "Nebraska",
    "formManifest.visaPurposePage.state.nevada": "Nevada",
    "formManifest.visaPurposePage.state.newHampshire": "New Hampshire",
    "formManifest.visaPurposePage.state.newJersey": "New Jersey",
    "formManifest.visaPurposePage.state.newMexico": "New Mexico",
    "formManifest.visaPurposePage.state.newYork": "New York",
    "formManifest.visaPurposePage.state.northCarolina": "North Carolina",
    "formManifest.visaPurposePage.state.northDakota": "North Dakota",
    "formManifest.visaPurposePage.state.northernMarianaIslands": "Northern Mariana Islands",
    "formManifest.visaPurposePage.state.ohio": "Ohio",
    "formManifest.visaPurposePage.state.oklahoma": "Oklahoma",
    "formManifest.visaPurposePage.state.oregon": "Oregon",
    "formManifest.visaPurposePage.state.pennsylvania": "Pennsylvania",
    "formManifest.visaPurposePage.state.puertoRico": "Puerto Rico",
    "formManifest.visaPurposePage.state.rhodeIsland": "Rhode Island",
    "formManifest.visaPurposePage.state.southCarolina": "South Carolina",
    "formManifest.visaPurposePage.state.southDakota": "South Dakota",
    "formManifest.visaPurposePage.state.tennessee": "Tennessee",
    "formManifest.visaPurposePage.state.texas": "Texas",
    "formManifest.visaPurposePage.state.utah": "Utah",
    "formManifest.visaPurposePage.state.vermont": "Vermont",
    "formManifest.visaPurposePage.state.virginIslands": "Virgin Islands",
    "formManifest.visaPurposePage.state.virginia": "Virginia",
    "formManifest.visaPurposePage.state.washington": "Washington",
    "formManifest.visaPurposePage.state.westVirginia": "West Virginia",
    "formManifest.visaPurposePage.state.wisconsin": "Wisconsin",
    "formManifest.visaPurposePage.state.wyoming": "Wyoming",
    "formManifest.visaPurposePage.travelPlans.arrivalCity.title": "Arrival City",
    "formManifest.visaPurposePage.travelPlans.arrivalDate.title": "Arrival Date",
    "formManifest.visaPurposePage.travelPlans.arrivalFlight.title": "Arrival Flight (if known)",
    "formManifest.visaPurposePage.travelPlans.departureCity.title": "Departure City",
    "formManifest.visaPurposePage.travelPlans.departureDate.title": "Departure Date",
    "formManifest.visaPurposePage.travelPlans.departureFlight.title": "Departure Flight (if known)",
    "formManifest.visaPurposePage.travelPlans.help.content":
        "If you are unsure of your Date of Arrival in U.S. or Date of Departure from U.S., please provide an estimate.",
    "formManifest.visaPurposePage.travelPlans.help.title": "Travel Plans",
    "formManifest.visaPurposePage.travelPlans.title": "Provide a complete itinerary for your travel to the U.S.",
    "formManifest.visaPurposePage.travelPlans.visitedLocations.location.title": "Location",
    "formManifest.visaPurposePage.travelPlans.visitedLocations.title": "Locations you plan to visit:",
    "formManifest.visaPurposePage.visaCategories.categoryA.A1-AM": "AMBASSADOR OR PUBLIC MINISTER (A1)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A1-CH": "CHILD OF AN A1 (A1)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A1-DP": "CAREER DIPLOMAT/CONSULAR OFFICER (A1)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A1-SP": "SPOUSE OF AN A1 (A1)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A2-CH": "CHILD OF AN A2 (A2)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A2-EM": "FOREIGN OFFICIAL/EMPLOYEE (A2)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A2-SP": "SPOUSE OF AN A2 (A2)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A3-CH": "CHILD OF AN A3 (A3)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A3-EM": "PERSONAL EMP. OF AN A1 OR A2 (A3)",
    "formManifest.visaPurposePage.visaCategories.categoryA.A3-SP": "SPOUSE OF AN A3 (A3)",
    "formManifest.visaPurposePage.visaCategories.categoryB.B1-B2": "TEMP. VISITOR FOR BUSINESS/PLEASURE (B1/B2)",
    "formManifest.visaPurposePage.visaCategories.categoryB.B1-CF": "TEMP. VISITOR FOR BUSINESS (B1)",
    "formManifest.visaPurposePage.visaCategories.categoryB.B2-TM": "TEMP. VISITOR FOR PLEASURE (B2)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C-TR": "ALIEN IN TRANSIT (C)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C1-CH": "CHILD OF A C1 (C1)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C1-SP": "SPOUSE OF A C1 (C1)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C1-TR": "ALIEN IN IMMEDIATE & CONTINUOUS TRANSIT (C1)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C2-CH": "CHILD OF A C2 (C2)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C2-SP": "SPOUSE OF A C2 (C2)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C2-TR": "ALIEN IN TRANSIT TO THE UN (C2)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C3-CH": "CHILD OF A C3 (C3)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C3-SP": "SPOUSE OF A C3 (C3)",
    "formManifest.visaPurposePage.visaCategories.categoryC.C3-TR": "FOREIGN GOV. OFFICIAL & FAMILY IN TRANSIT (C3)",
    "formManifest.visaPurposePage.visaCategories.categoryCNMI.CW-1": "CNMI WORKER (CW-1)",
    "formManifest.visaPurposePage.visaCategories.categoryCNMI.E2C-IN": "CNMI INVESTOR (E2C)",
    "formManifest.visaPurposePage.visaCategories.categoryD.D-D": "CREWMEMBER (D)",
    "formManifest.visaPurposePage.visaCategories.categoryD.D3-LI": "LIGHTERING CREWMEMBER (D3)",
    "formManifest.visaPurposePage.visaCategories.categoryE.E1-TR": "TREATY TRADER (E1)",
    "formManifest.visaPurposePage.visaCategories.categoryE.E2-TR": "TREATY INVESTOR (E2)",
    "formManifest.visaPurposePage.visaCategories.categoryE.E3-AUS": "AUSTRALIAN PROFESSIONAL (E3)",
    "formManifest.visaPurposePage.visaCategories.categoryF.F1-ST": "ACADEMIC STUDENT (F1)",
    "formManifest.visaPurposePage.visaCategories.categoryF.F2-CH": "CHILD OF F1 (F2)",
    "formManifest.visaPurposePage.visaCategories.categoryF.F2-SP": "SPOUSE OF F1 (F2)",
    "formManifest.visaPurposePage.visaCategories.categoryG.G1-EM": "INTERNATIONAL ORGANIZATION REPRESENTATIVE (G1)",
    "formManifest.visaPurposePage.visaCategories.categoryG.G2-EM": "INTERNATIONAL ORGANIZATION REPRESENTATIVE (G2)",
    "formManifest.visaPurposePage.visaCategories.categoryG.G3-EM": "INTERNATIONAL ORGANIZATION REPRESENTATIVE (G3)",
    "formManifest.visaPurposePage.visaCategories.categoryG.G4-EM": "INTERNATIONAL ORGANIZATION OFFICER/EMPLOYEE (G4)",
    "formManifest.visaPurposePage.visaCategories.categoryG.G5-EM": "INTERNATIONAL ORGANIZATION ATTENDANT (G5)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H1B-H1B": "SPECIALTY OCCUPATION (H1B)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H1C-NR": "NURSE IN SHORTAGE AREA (H1C)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H2A-AG": "AGRICULTURAL WORKER (H2A)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H2B-NA": "NONAGRICULTURAL WORKER (H2B)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H3-TR": "TRAINEE (H3)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H4-CH": "CHILD OF AN H (H4)",
    "formManifest.visaPurposePage.visaCategories.categoryH.H4-SP": "SPOUSE OF AN H (H4)",
    "formManifest.visaPurposePage.visaCategories.categoryI.I-FM": "FOREIGN MEDIA REPRESENTATIVE (I)",
    "formManifest.visaPurposePage.visaCategories.categoryJ.J1-EX": "EXCHANGE VISITOR (J1)",
    "formManifest.visaPurposePage.visaCategories.categoryJ.J2-CH": "CHILD OF J1 (J2)",
    "formManifest.visaPurposePage.visaCategories.categoryJ.J2-SP": "SPOUSE OF J1 (J2)",
    "formManifest.visaPurposePage.visaCategories.categoryK.K1-FI": "FIANCÉ(E) OF U.S. CITIZEN (K1)",
    "formManifest.visaPurposePage.visaCategories.categoryK.K2-CH": "CHILD OF K1 (K2)",
    "formManifest.visaPurposePage.visaCategories.categoryK.K3-SP": "SPOUSE OF U.S. CITIZEN (K3)",
    "formManifest.visaPurposePage.visaCategories.categoryK.K4-CH": "CHILD OF K3 (K4)",
    "formManifest.visaPurposePage.visaCategories.categoryL.L1A-EX": "INTRACOMPANY TRANSFEREE EXECUTIVE (L1A)",
    "formManifest.visaPurposePage.visaCategories.categoryL.L1B-SP": "INTRACOMPANY TRANSFEREE SPECIALIZED KNOWLEDGE (L1B)",
    "formManifest.visaPurposePage.visaCategories.categoryL.L2-CH": "CHILD OF L1 (L2)",
    "formManifest.visaPurposePage.visaCategories.categoryL.L2-SP": "SPOUSE OF L1 (L2)",
    "formManifest.visaPurposePage.visaCategories.categoryM.M1-ST": "VOCATIONAL STUDENT (M1)",
    "formManifest.visaPurposePage.visaCategories.categoryM.M2-CH": "CHILD OF M1 (M2)",
    "formManifest.visaPurposePage.visaCategories.categoryM.M2-SP": "SPOUSE OF M1 (M2)",
    "formManifest.visaPurposePage.visaCategories.categoryN.N8-CH": "CHILD OF A N8 (N9)",
    "formManifest.visaPurposePage.visaCategories.categoryN.N8-N8": "PARENT OF CERTAIN SPECIAL IMMIGRANT (N8)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-1": "NATO PRINCIPAL REPRESENTATIVE (NATO-1)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-2": "NATO REPRESENTATIVE (NATO-2)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-3": "NATO CLERICAL STAFF (NATO-3)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-4": "NATO OFFICIAL (NATO-4)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-5": "NATO EXPERT (NATO-5)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-6": "NATO CIVILIAN COMPONENT MEMBER (NATO-6)",
    "formManifest.visaPurposePage.visaCategories.categoryNATO.NATO-7": "NATO ATTENDANT (NATO-7)",
    "formManifest.visaPurposePage.visaCategories.categoryO.O1-EA": "ALIEN WITH EXTRAORDINARY ABILITY (O1)",
    "formManifest.visaPurposePage.visaCategories.categoryO.O2-AS": "ASSISTANT TO O1 (O2)",
    "formManifest.visaPurposePage.visaCategories.categoryO.O3-CH": "CHILD OF O1 OR O2 (O3)",
    "formManifest.visaPurposePage.visaCategories.categoryO.O3-SP": "SPOUSE OF O1 OR O2 (O3)",
    "formManifest.visaPurposePage.visaCategories.categoryP.P1-AT": "INTERNATIONALLY RECOGNIZED ATHLETE/ENTERTAINER (P1)",
    "formManifest.visaPurposePage.visaCategories.categoryP.P2-AR": "ARTIST/ENTERTAINER IN RECIPROCAL EXCHANGE (P2)",
    "formManifest.visaPurposePage.visaCategories.categoryP.P3-CU": "ARTIST/ENTERTAINER IN CULTURAL PROGRAM (P3)",
    "formManifest.visaPurposePage.visaCategories.categoryP.P4-CH": "CHILD OF P1, P2, OR P3 (P4)",
    "formManifest.visaPurposePage.visaCategories.categoryP.P4-SP": "SPOUSE OF P1, P2, OR P3 (P4)",
    "formManifest.visaPurposePage.visaCategories.categoryPAROLEBEN.PAROLE-BEN": "PAROLE BENEFICIARY",
    "formManifest.visaPurposePage.visaCategories.categoryPAROLEBEN.PAROLE-CIS": "CIS PAROLE",
    "formManifest.visaPurposePage.visaCategories.categoryPAROLEBEN.PAROLE-HUM": "HUMANITARIAN PAROLE",
    "formManifest.visaPurposePage.visaCategories.categoryPAROLEBEN.PAROLE-PUB": "PUBLIC INTEREST PAROLE",
    "formManifest.visaPurposePage.visaCategories.categoryQ.Q1-CU": "CULTURAL EXCHANGE VISITOR (Q1)",
    "formManifest.visaPurposePage.visaCategories.categoryQ.Q1-CX": "",
    "formManifest.visaPurposePage.visaCategories.categoryQ.Q2-IR": "IRISH PEACE PROCESS CULTURAL EXCHANGE VISITOR (Q2)",
    "formManifest.visaPurposePage.visaCategories.categoryQ.Q3-CH": "CHILD OF Q1 OR Q2 (Q3)",
    "formManifest.visaPurposePage.visaCategories.categoryQ.Q3-SP": "SPOUSE OF Q1 OR Q2 (Q3)",
    "formManifest.visaPurposePage.visaCategories.categoryR.R1-RE": "RELIGIOUS WORKER (R1)",
    "formManifest.visaPurposePage.visaCategories.categoryR.R1-RW": "",
    "formManifest.visaPurposePage.visaCategories.categoryR.R2-CH": "CHILD OF R1 (R2)",
    "formManifest.visaPurposePage.visaCategories.categoryR.R2-SP": "SPOUSE OF R1 (R2)",
    "formManifest.visaPurposePage.visaCategories.categoryS.S5-CR": "INFORMANT (S5)",
    "formManifest.visaPurposePage.visaCategories.categoryS.S6-TE": "WITNESS (S6)",
    "formManifest.visaPurposePage.visaCategories.categoryS.S7-CH": "CHILD OF S5 OR S6 (S7)",
    "formManifest.visaPurposePage.visaCategories.categoryS.S7-SP": "SPOUSE OF S5 OR S6 (S7)",
    "formManifest.visaPurposePage.visaCategories.categoryT.T1-VI": "VICTIM OF TRAFFICKING (T1)",
    "formManifest.visaPurposePage.visaCategories.categoryT.T2-CH": "CHILD OF T1 (T2)",
    "formManifest.visaPurposePage.visaCategories.categoryT.T2-SP": "SPOUSE OF T1 (T2)",
    "formManifest.visaPurposePage.visaCategories.categoryT.T3-PA": "PARENT OF T1 (T3)",
    "formManifest.visaPurposePage.visaCategories.categoryT.T4-SI": "SIBLING OF T1 (T4)",
    "formManifest.visaPurposePage.visaCategories.categoryTDTN.TD-CH": "CHILD OF TN (TD)",
    "formManifest.visaPurposePage.visaCategories.categoryTDTN.TD-SP": "SPOUSE OF TN (TD)",
    "formManifest.visaPurposePage.visaCategories.categoryTDTN.TN-PR": "NAFTA PROFESSIONAL (TN)",
    "formManifest.visaPurposePage.visaCategories.categoryU.U1-VI": "VICTIM OF CRIMINAL ACTIVITY (U1)",
    "formManifest.visaPurposePage.visaCategories.categoryU.U2-CH": "CHILD OF U1 (U2)",
    "formManifest.visaPurposePage.visaCategories.categoryU.U2-SP": "SPOUSE OF U1 (U2)",
    "formManifest.visaPurposePage.visaCategories.categoryU.U3-PA": "PARENT OF U1 (U3)",
    "formManifest.visaPurposePage.visaCategories.categoryU.U4-SI": "SIBLING OF U1 (U4)",
    "formManifest.visaPurposePage.visaCategories.visaType.A": "FOREIGN GOVERNMENT OFFICIAL (A)",
    "formManifest.visaPurposePage.visaCategories.visaType.B": "TEMP. BUSINESS OR PLEASURE VISITOR (B)",
    "formManifest.visaPurposePage.visaCategories.visaType.C": "ALIEN IN TRANSIT (C)",
    "formManifest.visaPurposePage.visaCategories.visaType.CNMI": "CNMI WORKER OR INVESTOR (CW/E2C)",
    "formManifest.visaPurposePage.visaCategories.visaType.D": "CREWMEMBER (D)",
    "formManifest.visaPurposePage.visaCategories.visaType.E": "TREATY TRADER OR INVESTOR (E)",
    "formManifest.visaPurposePage.visaCategories.visaType.F": "ACADEMIC OR LANGUAGE STUDENT (F)",
    "formManifest.visaPurposePage.visaCategories.visaType.G": "INTERNATIONAL ORGANIZATION REP./EMP. (G)",
    "formManifest.visaPurposePage.visaCategories.visaType.H": "TEMPORARY WORKER (H)",
    "formManifest.visaPurposePage.visaCategories.visaType.I": "FOREIGN MEDIA REPRESENTATIVE (I)",
    "formManifest.visaPurposePage.visaCategories.visaType.J": "EXCHANGE VISITOR (J)",
    "formManifest.visaPurposePage.visaCategories.visaType.K": "FIANCÉ(E) OR SPOUSE OF A U.S. CITIZEN (K)",
    "formManifest.visaPurposePage.visaCategories.visaType.L": "INTRACOMPANY TRANSFEREE (L)",
    "formManifest.visaPurposePage.visaCategories.visaType.M": "VOCATIONAL/NONACADEMIC STUDENT (M)",
    "formManifest.visaPurposePage.visaCategories.visaType.N": "OTHER (N)",
    "formManifest.visaPurposePage.visaCategories.visaType.NATO": "NATO STAFF (NATO)",
    "formManifest.visaPurposePage.visaCategories.visaType.O": "ALIEN WITH EXTRAORDINARY ABILITY (O)",
    "formManifest.visaPurposePage.visaCategories.visaType.P": "INTERNATIONALLY RECOGNIZED ALIEN (P)",
    "formManifest.visaPurposePage.visaCategories.visaType.PAROLE-BEN": "PAROLE BENEFICIARY (PARCIS)",
    "formManifest.visaPurposePage.visaCategories.visaType.Q": "CULTURAL EXCHANGE VISITOR (Q)",
    "formManifest.visaPurposePage.visaCategories.visaType.R": "RELIGIOUS WORKER (R)",
    "formManifest.visaPurposePage.visaCategories.visaType.S": "INFORMANT OR WITNESS (S)",
    "formManifest.visaPurposePage.visaCategories.visaType.T": "VICTIM OF TRAFFICKING (T)",
    "formManifest.visaPurposePage.visaCategories.visaType.TD/TN": "NAFTA PROFESSIONAL (TD/TN)",
    "formManifest.visaPurposePage.visaCategories.visaType.U": "VICTIM OF CRIMINAL ACTIVITY (U)",
    "formNavigation.next": "Next",
    "formNavigation.previous": "Previous",
    "formNavigation.showingSectionOf": "Showing Section {{position}} of {{total}}",
    "formOverviewPage.description": "Overview of your form responses",
    "formOverviewPage.title": "Form Overview",
    "formSectionLabels.additionalOccupationPage": "Additional Occupation Details",
    "formSectionLabels.addressAndPhonePage": "Address and Phone Details",
    "formSectionLabels.contactInfoPage": "Contact Information",
    "formSectionLabels.deceasedSpouseInfoPage": "Deceased Spouse Information",
    "formSectionLabels.familyInfoPage": "Family Information",
    "formSectionLabels.passportPage": "Passport Information",
    "formSectionLabels.personalInfoPage1": "Personal Information - Part 1",
    "formSectionLabels.personalInfoPage2": "Personal Information - Part 2",
    "formSectionLabels.presentOccupationPage": "Current Occupation",
    "formSectionLabels.previousOccupationPage": "Previous Occupation",
    "formSectionLabels.previousUsTravelPage": "Previous U.S. Travel History",
    "formSectionLabels.securityBackgroundPage1": "Security Background - Part 1",
    "formSectionLabels.securityBackgroundPage2": "Security Background - Part 2",
    "formSectionLabels.securityBackgroundPage3": "Security Background - Part 3",
    "formSectionLabels.securityBackgroundPage4": "Security Background - Part 4",
    "formSectionLabels.securityBackgroundPage5": "Security Background - Part 5",
    "formSectionLabels.spouseInfoPage": "Spouse Information",
    "formSectionLabels.studentVisaPage1": "Student Visa Details - Part 1",
    "formSectionLabels.studentVisaPage2": "Student Visa Details - Part 2",
    "formSectionLabels.temporaryVisaPage": "Temporary Visa Information",
    "formSectionLabels.travelCompanionsPage": "Travel Companions",
    "formSectionLabels.visaPurposePage": "Purpose of Visa",
    "formSectionListPage.breadcrumb.forms": "Forms",
    "formSectionListPage.breadcrumb.workflows": "Workflows",
    "formSectionListPage.businessWorkspaceActions.aiLabel": "AI",
    "formSectionListPage.businessWorkspaceActions.description":
        "Create secure client links for form collaboration or use AI to automatically translate all text fields to English.",
    "formSectionListPage.businessWorkspaceActions.resetLabel": "Reset",
    "formSectionListPage.businessWorkspaceActions.title": "Business Workspace Actions",
    "formSectionListPage.createClientLinkButton": "Create Client Link",
    "formSectionListPage.description":
        "This is a list of all the sections in the form, each with its name and a link to edit. After completing all sections, you can generate a US DS-160 visa application, which our form filler will use to help you efficiently complete your DS-160 form.",
    "formSectionListPage.formNamePlaceholder": "Enter form name",
    "formSectionListPage.heading": "Form Sections",
    "formSectionListPage.note": "Note: All form answers must be filled out in English as required by the US State Department.",
    "formSectionListPage.renameFormButton": "Rename form",
    "formSectionListPage.resetTranslationsButton.default": "Reset Translations",
    "formSectionListPage.resetTranslationsButton.loading": "Resetting...",
    "formSectionListPage.table.editButton": "Edit",
    "formSectionListPage.table.headers.questionsAnswered": "Questions Answered",
    "formSectionListPage.table.headers.sectionName": "Section Name",
    "formSectionListPage.table.headers.status": "Status",
    "formSectionListPage.translateAllFieldsButton.default": "Translate All Fields",
    "formSectionListPage.translateAllFieldsButton.loading": "Translating...",
    "formSectionListPage.translateAllFieldsButton.success": "All fields have been successfully translated to English",
    "formSectionStatus.completed": "Completed",
    "formSectionStatus.inProgress": "In Progress",
    "formSectionStatus.notStarted": "Not Started",
    "formSubmissionsPage.breadcrumb.forms": "Forms",
    "formSubmissionsPage.breadcrumb.workflows": "Workflows",
    "formSubmissionsPage.breadcrumb.submissions": "Submissions",
    "formSubmissionsPage.completed": "Completed",
    "formSubmissionsPage.created": "Created",
    "formSubmissionsPage.description": "View and manage submissions for this form",
    "formSubmissionsPage.errorLoading": "Error loading submissions. Please try again.",
    "formSubmissionsPage.noSubmissions.description": "No submissions have been created for this form yet.",
    "formSubmissionsPage.noSubmissions.title": "No submissions",
    "formSubmissionsPage.statusLabels.awaitingCaptcha": "Awaiting captcha",
    "formSubmissionsPage.statusLabels.completed": "Completed",
    "formSubmissionsPage.statusLabels.ds160Error": "DS160 Form Error",
    "formSubmissionsPage.statusLabels.errored": "Errored",
    "formSubmissionsPage.statusLabels.fillingForm": "Filling form",
    "formSubmissionsPage.statusLabels.inProgress": "In progress",
    "formSubmissionsPage.statusLabels.pendingStart": "Pending start",
    "formSubmissionsPage.submissionCount.plural": "submissions",
    "formSubmissionsPage.submissionCount.singular": "submission",
    "formSubmissionsPage.submissionsTitle": "Submissions",
    "formSubmissionsPage.title": "Form Submissions",
    "formSubmissionsPage.view": "View",
    "functions.relativeTime": "{{date, fromNow}}",
    "homePage.description": "Turn 8 hours of manual lead research into 10 minutes with automated workflows",
    "homePage.title": "8 Hours → 10 Minutes | Sales Automation",
    "howItWorksPage.commonProblems.badge": "The Problem",
    "howItWorksPage.commonProblems.cta.description": "What takes 8 hours manually now takes 10 minutes with automation.",
    "howItWorksPage.commonProblems.cta.heading": "Save 8 Hours Every Week",
    "howItWorksPage.commonProblems.cta.subtext": "↓ See our simple 3-step process below ↓",
    "howItWorksPage.commonProblems.description":
        "You spend hours researching leads, visiting websites, and manually categorizing prospects. Then you do it all over again tomorrow. Your sales team deserves better.",
    "howItWorksPage.commonProblems.guideLink": "",
    "howItWorksPage.commonProblems.heading": "Manual Sales Research is Broken",
    "howItWorksPage.commonProblems.nightmare.confusingQuestions.description":
        "Which leads should you prioritize? Without data, you're just guessing and wasting time on dead ends.",
    "howItWorksPage.commonProblems.nightmare.confusingQuestions.title": "No Clear Priorities",
    "howItWorksPage.commonProblems.nightmare.heading": "The Manual Sales Nightmare",
    "howItWorksPage.commonProblems.nightmare.restartHell.description":
        "Copy-pasting between spreadsheets, CRMs, and browser tabs. Context switching kills productivity.",
    "howItWorksPage.commonProblems.nightmare.restartHell.title": "Endless Copy-Paste",
    "howItWorksPage.commonProblems.nightmare.sessionExpires.description":
        "Hours spent researching each lead manually. By the time you finish, the opportunity may be gone.",
    "howItWorksPage.commonProblems.nightmare.sessionExpires.title": "Time Wasted",
    "howItWorksPage.commonProblems.solution.description":
        "Upload your leads once, let automation do the research. Focus on selling, not researching.",
    "howItWorksPage.commonProblems.solution.features.autoSave": "Automatic enrichment",
    "howItWorksPage.commonProblems.solution.features.completion": "Minutes not hours",
    "howItWorksPage.commonProblems.solution.features.guidance": "Actionable insights",
    "howItWorksPage.commonProblems.solution.heading": "With SalesDingo",
    "howItWorksPage.commonProblems.stats.experience.description": "Of sales time is spent on non-selling activities",
    "howItWorksPage.commonProblems.stats.experience.metric": "65%",
    "howItWorksPage.commonProblems.stats.experience.subtext": "According to Salesforce research",
    "howItWorksPage.commonProblems.stats.timeNeeded.description": "Time spent researching per lead manually",
    "howItWorksPage.commonProblems.stats.timeNeeded.metric": "15-30 min",
    "howItWorksPage.commonProblems.stats.timeNeeded.subtext": "Before you even make first contact",
    "howItWorksPage.commonProblems.stats.timeout.description": "Leads go cold within",
    "howItWorksPage.commonProblems.stats.timeout.metric": "5 min",
    "howItWorksPage.commonProblems.stats.timeout.subtext": "Speed to lead matters more than ever",
    "howItWorksPage.commonProblems.testimonial.altText": "",
    "howItWorksPage.commonProblems.testimonial.linkText": "",
    "howItWorksPage.commonProblems.testimonial.quote": "",
    "howItWorksPage.commonProblems.testimonial.username": "",
    "howItWorksPage.description":
        "Turn 8 hours of manual lead research into 10 minutes. Import leads, run automated workflows, and export enriched, tiered prospects.",
    "howItWorksPage.detailedProcess.badge": "Simple Process",
    "howItWorksPage.detailedProcess.description": "Get from raw leads to prioritized prospects in minutes",
    "howItWorksPage.detailedProcess.heading": "Three Steps to Smarter Sales",
    "howItWorksPage.detailedProcess.screenshots.description": "See exactly how workflows automate your sales research",
    "howItWorksPage.detailedProcess.screenshots.heading": "Watch Our Process in Action",
    "howItWorksPage.detailedProcess.screenshots.step1.altText": "Lead import interface",
    "howItWorksPage.detailedProcess.screenshots.step1.fallbackDescription": "Video not supported by your browser",
    "howItWorksPage.detailedProcess.screenshots.step1.fallbackHeading": "Step 1: Import Interface",
    "howItWorksPage.detailedProcess.screenshots.step2.fallbackDescription": "Video not supported by your browser",
    "howItWorksPage.detailedProcess.screenshots.step2.fallbackHeading": "Step 2: Workflow Execution",
    "howItWorksPage.detailedProcess.screenshots.step3.heading": "Download your enriched and tiered leads ready for outreach.",
    "howItWorksPage.detailedProcess.stats.countriesServed.description": "Leads processed",
    "howItWorksPage.detailedProcess.stats.countriesServed.metric": "10k+",
    "howItWorksPage.detailedProcess.stats.returningUser.description": "Average time per lead",
    "howItWorksPage.detailedProcess.stats.returningUser.metric": "< 30s",
    "howItWorksPage.detailedProcess.stats.timeoutErrors.description": "Manual research needed",
    "howItWorksPage.detailedProcess.stats.timeoutErrors.metric": "Zero",
    "howItWorksPage.detailedProcess.steps.chooseConsulate.description":
        "Our workflows automatically research each lead, analyze their website, and classify them based on your criteria.",
    "howItWorksPage.detailedProcess.steps.chooseConsulate.features.errorHandling": "Automatic retries",
    "howItWorksPage.detailedProcess.steps.chooseConsulate.features.realTimeStatus": "Real-time progress tracking",
    "howItWorksPage.detailedProcess.steps.chooseConsulate.features.successConfirmation": "Detailed results per lead",
    "howItWorksPage.detailedProcess.steps.chooseConsulate.number": "02",
    "howItWorksPage.detailedProcess.steps.chooseConsulate.title": "Run Workflow",
    "howItWorksPage.detailedProcess.steps.copyApplicationId.description":
        "Download your enriched leads with insights, tier classifications, and research notes ready for your CRM.",
    "howItWorksPage.detailedProcess.steps.copyApplicationId.features.appointmentGuide": "CRM-ready format",
    "howItWorksPage.detailedProcess.steps.copyApplicationId.features.confirmationPage": "Enriched data export",
    "howItWorksPage.detailedProcess.steps.copyApplicationId.features.copyReady": "Tier classifications included",
    "howItWorksPage.detailedProcess.steps.copyApplicationId.number": "03",
    "howItWorksPage.detailedProcess.steps.copyApplicationId.title": "Export Enriched Results",
    "howItWorksPage.detailedProcess.steps.fillInformation.description":
        "Upload a CSV with your leads. Just add website URLs and we'll handle the rest.",
    "howItWorksPage.detailedProcess.steps.fillInformation.features.autoSave": "CSV upload support",
    "howItWorksPage.detailedProcess.steps.fillInformation.features.clearLabels": "Flexible column mapping",
    "howItWorksPage.detailedProcess.steps.fillInformation.features.progressTracking": "Bulk import ready",
    "howItWorksPage.detailedProcess.steps.fillInformation.number": "01",
    "howItWorksPage.detailedProcess.steps.fillInformation.title": "Import Your Leads",
    "howItWorksPage.faqSection.badge": "Quick Answers",
    "howItWorksPage.faqSection.description": "Get instant answers about sales automation workflows",
    "howItWorksPage.faqSection.faqs.duration.answer":
        "Most workflows complete in under 30 seconds per lead. A batch of 100 leads typically processes in about 15-20 minutes.",
    "howItWorksPage.faqSection.faqs.duration.question": "How long does processing take?",
    "howItWorksPage.faqSection.faqs.legal.answer":
        "Absolutely. We only access publicly available information from company websites. Your data is encrypted and never shared with third parties.",
    "howItWorksPage.faqSection.faqs.legal.question": "Is my data secure?",
    "howItWorksPage.faqSection.faqs.mistakes.answer":
        "You can re-run workflows anytime with updated criteria. Results are never permanent until you export them.",
    "howItWorksPage.faqSection.faqs.mistakes.question": "What if I need to change my criteria?",
    "howItWorksPage.faqSection.faqs.saveReturn.answer":
        "Yes! Your workflows and results are saved automatically. Return anytime to view past results or run new workflows.",
    "howItWorksPage.faqSection.faqs.saveReturn.question": "Can I save and return later?",
    "howItWorksPage.faqSection.faqs.visaTypes.answer":
        "We support lead tiering, website analysis, company research, and custom classification workflows. More workflow types coming soon.",
    "howItWorksPage.faqSection.faqs.visaTypes.question": "What types of workflows are available?",
    "howItWorksPage.faqSection.heading": "Common Questions",
    "howItWorksPage.faqSection.successStories.description": "",
    "howItWorksPage.faqSection.successStories.heading": "",
    "howItWorksPage.faqSection.successStories.testimonial1.altText": "",
    "howItWorksPage.faqSection.successStories.testimonial1.platform": "",
    "howItWorksPage.faqSection.successStories.testimonial1.quote1": "",
    "howItWorksPage.faqSection.successStories.testimonial1.quote2": "",
    "howItWorksPage.faqSection.successStories.testimonial1.quote3": "",
    "howItWorksPage.faqSection.successStories.testimonial1.username": "",
    "howItWorksPage.faqSection.successStories.testimonial2.platform": "",
    "howItWorksPage.faqSection.successStories.testimonial2.quote": "",
    "howItWorksPage.faqSection.successStories.testimonial2.username": "",
    "howItWorksPage.faqSection.support.button": "Contact Support",
    "howItWorksPage.faqSection.support.description": "Our team is here to help you get started",
    "howItWorksPage.faqSection.support.heading": "Still Have Questions?",
    "howItWorksPage.finalCta.heading": "Ready to Save 8 Hours?",
    "howItWorksPage.finalCta.primaryButton": "Get Started Free",
    "howItWorksPage.finalCta.secondaryButton": "Learn More",
    "howItWorksPage.finalCta.subheading": "Turn 8 hours of manual lead research into 10 minutes with automated workflows.",
    "howItWorksPage.finalCta.trustBadges.fastProcessing": "Fast Processing",
    "howItWorksPage.finalCta.trustBadges.sslEncrypted": "SSL Encrypted",
    "howItWorksPage.finalCta.trustBadges.support": "Email Support",
    "howItWorksPage.hero.benefits.noTimeouts.description": "Process thousands of leads while you focus on closing deals.",
    "howItWorksPage.hero.benefits.noTimeouts.title": "Scale Effortlessly",
    "howItWorksPage.hero.benefits.oneClickRenewals.description": "Define your criteria once, apply it to every lead automatically.",
    "howItWorksPage.hero.benefits.oneClickRenewals.title": "Consistent Tiering",
    "howItWorksPage.hero.benefits.saveProgress.description":
        "Automatically analyze websites and enrich your leads with actionable insights.",
    "howItWorksPage.hero.benefits.saveProgress.title": "Automated Research",
    "howItWorksPage.hero.description":
        "What takes 8 hours of manual research now takes 10 minutes. Import your leads, run automated workflows, and get enriched, tiered prospects ready for outreach.",
    "howItWorksPage.hero.heading": "8 Hours → 10 Minutes",
    "howItWorksPage.hero.primaryButton": "Start Free",
    "howItWorksPage.hero.secondaryButton": "See How It Works",
    "howItWorksPage.hero.subheading": "Sales Research Automation",
    "howItWorksPage.hero.subtext": "Turn 8 hours of manual lead research into 10 minutes with automated workflows.",
    "howItWorksPage.hero.trustBadge": "Sales Automation Platform",
    "howItWorksPage.mobileCta.text": "Get Started",
    "howItWorksPage.testimonial.altText": "",
    "howItWorksPage.testimonial.heading": "",
    "howItWorksPage.testimonial.linkText": "",
    "howItWorksPage.testimonial.quote": "",
    "howItWorksPage.testimonial.username": "",
    "howItWorksPage.testimonials.commentedOn": "",
    "howItWorksPage.testimonials.heading": "",
    "howItWorksPage.testimonials.reply": "",
    "howItWorksPage.testimonials.starsAltText": "",
    "howItWorksPage.testimonials.thisPost": "",
    "howItWorksPage.testimonials.upvotes": "",
    "howItWorksPage.testimonials.viewOnReddit": "",
    "howItWorksPage.title": "8 Hours → 10 Minutes | SalesDingo",
    "languageSwitcher.english": "English",
    "languageSwitcher.russian": "Русский",
    "languageSwitcher.selectLanguage": "Select language",
    "leadQualificationJobsList.columnActions": "Actions",
    "leadQualificationJobsList.columnCreated": "Created",
    "leadQualificationJobsList.columnProgress": "Progress",
    "leadQualificationJobsList.columnPrompt": "Prompt",
    "leadQualificationJobsList.columnStatus": "Status",
    "leadQualificationJobsList.errorLoading": "Failed to load jobs. Please try again.",
    "leadQualificationJobsList.noJobs": "No lead qualification jobs yet. Upload a CSV to get started.",
    "leadQualificationJobsList.title": "Recent Jobs",
    "leadQualificationJobsList.viewDetails": "View Details",
    "leadQualificationResults.columnClassification": "Classification",
    "leadQualificationResults.columnRow": "Row",
    "leadQualificationResults.columnStatus": "Status",
    "leadQualificationResults.columnWebsite": "Website",
    "leadQualificationResults.downloadCsv": "Download CSV",
    "leadQualificationResults.promptLabel": "Classification Prompt",
    "leadQualificationResults.statusCompleted": "Completed",
    "leadQualificationResults.statusFailed": "Failed",
    "leadQualificationResults.statusPending": "Pending",
    "leadQualificationResults.summary": "{{completed}} completed, {{pending}} pending of {{total}} total",
    "leadTieringJobsList.columnActions": "Actions",
    "leadTieringJobsList.columnCreated": "Created",
    "leadTieringJobsList.columnProgress": "Progress",
    "leadTieringJobsList.columnPrompt": "Prompt",
    "leadTieringJobsList.columnStatus": "Status",
    "leadTieringJobsList.errorLoading": "Failed to load jobs. Please try again.",
    "leadTieringJobsList.noJobs": "No lead tiering jobs yet. Upload a CSV to get started.",
    "leadTieringJobsList.title": "Recent Jobs",
    "leadTieringJobsList.viewDetails": "View Details",
    "leadTieringResults.columnRow": "Row",
    "leadTieringResults.columnStatus": "Status",
    "leadTieringResults.columnTier": "Tier",
    "leadTieringResults.columnLinkedin": "LinkedIn",
    "leadTieringResults.downloadCsv": "Download CSV",
    "leadTieringResults.promptLabel": "Tiering Prompt",
    "leadTieringResults.statusCompleted": "Completed",
    "leadTieringResults.statusFailed": "Failed",
    "leadTieringResults.statusPending": "Pending",
    "leadTieringResults.summary": "{{completed}} completed, {{pending}} pending of {{total}} total",
    loading: "Loading...",
    "loginPage.description": "Login to your headbot account.",
    "loginPage.email": "Email",
    "loginPage.login": "Login",
    "loginPage.noAccountSignup": "No account? <1>Sign up</1>",
    "loginPage.password": "Password",
    "loginPage.title": "Login",
    "myForms.breadcrumb": "Forms",
    "myForms.filters.member.all": "All members",
    "myForms.filters.member.label": "Member",
    "myForms.filters.member.unknown": "Unknown member",
    "myForms.filters.noResults": "No forms match your filters.",
    "myForms.filters.search.label": "Search forms",
    "myForms.filters.search.placeholder": "Search by form name...",
    "myForms.filters.showing": "Showing {{filteredCount}} of {{totalForms}} forms",
    "myForms.filters.sort.dateCreated": "Date created",
    "myForms.filters.sort.name": "Name",
    "myForms.filters.sort.progress": "Progress",
    "myForms.filters.sort.status": "Status",
    "myForms.filters.sortBy": "Sort by",
    "myForms.filters.status.all": "All statuses",
    "myForms.filters.status.completed": "Completed",
    "myForms.filters.status.inProgress": "In progress",
    "myForms.filters.status.notStarted": "Not started",
    "myForms.filters.statusLabel": "Status",
    "myForms.newForm.description": "Create a new DS160 form",
    "myForms.newForm.title": "New Form",
    "myForms.noForms.description": "Get started by creating a new DS160 form.",
    "myForms.noForms.title": "No Forms",
    "navigation.blog": "Blog",
    "navigation.dashboard": "Dashboard →",
    "navigation.home": "Home",
    "navigation.login": "Login",
    "navigation.logout": "Logout",
    "navigation.pricing": "Pricing",
    "navigation.resources": "Resources",
    "navigation.signup": "Signup",
    "newSubmissionPage.description": "Create a new DS160 Form Pilot Submission",
    "newSubmissionPage.title": "New Submission",
    "notFoundPage.description": "The page you are looking for does not exist.",
    "notFoundPage.goHome": "Go to Homepage",
    "notFoundPage.goLogin": "Go to Login",
    "notFoundPage.heading": "Page Not Found",
    "notFoundPage.message":
        "Sorry, the page you're looking for doesn't exist or has been moved. Please check the URL or navigate back to our homepage.",
    "notFoundPage.title": "Page Not Found",
    "pricingPage.description": "Choose a volume that works for you",
    "pricingPage.hero.benefits.allVisaTypes.description": "Works for every DS-160 form",
    "pricingPage.hero.benefits.allVisaTypes.title": "All Visa Types",
    "pricingPage.hero.benefits.secure.description": "Bank-level encryption",
    "pricingPage.hero.benefits.secure.title": "Secure",
    "pricingPage.hero.benefits.timeSaved.description": "Complete in minutes, not hours",
    "pricingPage.hero.benefits.timeSaved.title": "2+ Hours Saved",
    "pricingPage.hero.description": "One flat fee. No surprises. Complete your DS-160 in minutes instead of hours.",
    "pricingPage.hero.heading": "Simple, Transparent",
    "pricingPage.hero.secondaryHeading": "Pricing",
    "pricingPage.hero.successBadge": "Over thousands of forms completed successfully",
    "pricingPage.hero.tiers.family.badge": "Best Value",
    "pricingPage.hero.tiers.family.bundleDescription": "Save 20% per form",
    "pricingPage.hero.tiers.family.buttonText": "Buy 3+",
    "pricingPage.hero.tiers.family.description": "Great for families or multiple applications.",
    "pricingPage.hero.tiers.family.features.differentVisaTypes": "Support for different visa types",
    "pricingPage.hero.tiers.family.features.everything": "Everything in Single Form",
    "pricingPage.hero.tiers.family.features.familyTravel": "Perfect for family travel",
    "pricingPage.hero.tiers.family.features.reuseInformation": "Reuse information across applications",
    "pricingPage.hero.tiers.family.features.savings": "Significant per-form savings",
    "pricingPage.hero.tiers.family.name": "Family Pack",
    "pricingPage.hero.tiers.single.badge": "Most Popular",
    "pricingPage.hero.tiers.single.bundleDescription": "Single unit pricing",
    "pricingPage.hero.tiers.single.buttonText": "Buy 1",
    "pricingPage.hero.tiers.single.description": "Perfect for individuals applying for any US visa.",
    "pricingPage.hero.tiers.single.features.autoValidation": "Automatic form validation",
    "pricingPage.hero.tiers.single.features.confirmationPage": "Instant confirmation page with barcode",
    "pricingPage.hero.tiers.single.features.copyReady": "Copy-ready application ID",
    "pricingPage.hero.tiers.single.features.fastCompletion": "Complete DS-160 in under 3 minutes",
    "pricingPage.hero.tiers.single.features.noTimeouts": "No timeout errors or lost progress",
    "pricingPage.hero.tiers.single.features.visaTypes": "Works for all visa types (F-1, H-1B, B-1/B-2, etc.)",
    "pricingPage.hero.tiers.single.name": "Single Form",
    "pricingPage.hero.trustBadges.fiveStarSupport": "5-Star Support",
    "pricingPage.hero.trustBadges.instantAccess": "Instant Access",
    "pricingPage.hero.trustBadges.securePayment": "Secure Payment",
    "pricingPage.supportText": "Questions? Contact our support team for help choosing the right option.",
    "pricingPage.title": "Pricing",
    "questionUI.agencyEdit": "Agency Edit",
    "questionUI.no": "No",
    "questionUI.notApplicable": "NA",
    "questionUI.originalReadOnly": "Original - Read Only",
    "questionUI.selectAnOption": "SELECT AN OPTION",
    "questionUI.translateField": "Translate to English",
    "questionUI.yes": "Yes",
    "resourcesPage.description": "A list of useful US DS-160 Visa Application Resources",
    "resourcesPage.title": "Resources",
    "sampleDS160FormsPage.description": "Sample Completed DS-160 Visa Application Forms With PDF Available For Download",
    "sampleDS160FormsPage.title": "Sample DS160 Forms",
    "scraperJobDetails.configTitle": "Configuration",
    "scraperJobDetails.labelBrokenLinksFound": "Broken Links",
    "scraperJobDetails.labelCompleted": "Completed",
    "scraperJobDetails.labelConcurrency": "Concurrency",
    "scraperJobDetails.labelCreated": "Created",
    "scraperJobDetails.labelDomain": "Domain",
    "scraperJobDetails.labelDuration": "Duration",
    "scraperJobDetails.labelError": "Error",
    "scraperJobDetails.labelExternalLinksFound": "External Links",
    "scraperJobDetails.labelMaxDepth": "Max Depth",
    "scraperJobDetails.labelMaxPages": "Max Pages",
    "scraperJobDetails.labelStartUrl": "Start URL",
    "scraperJobDetails.labelStatus": "Status",
    "scraperJobDetails.labelTotalPagesScraped": "Pages Scraped",
    "scraperJobDetails.labelUniqueUrlsFound": "Unique URLs",
    "scraperJobDetails.statisticsTitle": "Statistics",
    "scraperJobDetails.title": "Scraper Job Details",
    "signupPage.alreadyHaveAnAccount": "Already have an account? <1>Login</1>",
    "signupPage.description": "Create your headbot account.",
    "signupPage.email": "Email",
    "signupPage.password": "Password",
    "signupPage.signup": "Signup",
    "signupPage.title": "Signup",
    "submissionsPage.breadcrumb": "Submissions",
    "submissionsPage.createSubmissionDescription": "Create a DS160 Submission from an existing DS160 form.",
    "submissionsPage.createSubmissionTitle": "DS160 Submissions",
    "submissionsPage.created": "Created",
    "submissionsPage.delete": "Delete",
    "submissionsPage.description": "Manage and track your DS160 form submissions",
    "submissionsPage.openOptions": "Open options",
    "submissionsPage.statusLabels.awaitingCaptcha": "Awaiting captcha",
    "submissionsPage.statusLabels.completed": "Completed",
    "submissionsPage.statusLabels.ds160Error": "DS160 Form Error",
    "submissionsPage.statusLabels.errored": "Errored",
    "submissionsPage.statusLabels.fillingForm": "Filling form",
    "submissionsPage.statusLabels.inProgress": "In progress",
    "submissionsPage.statusLabels.pendingStart": "Pending start",
    "submissionsPage.title": "Submissions",
    "submissionsPage.viewApplication": "View Application",
    "usVisaPhotoCheckerPage.description": "Free tool to check if your US Visa Photo meets the digital requirements",
    "usVisaPhotoCheckerPage.title": "US Visa Photo Checker",
    "validation.date.mustBeFuture": "Date must be in the future",
    "validation.date.mustBePast": "Date must be in the past",
    "validation.phoneNumber.digitsOnly": "Phone number must be 5-15 digits with no spaces or hyphens",
    "viewSubmissionPage.description": "View a DS160 Form Pilot Submission",
    "viewSubmissionPage.title": "View Submission",
    "workflowDetails.breadcrumbDetails": "Details",
    "workflowDetails.breadcrumbWorkflows": "Workflows",
    "workflowDetails.columnCompleted": "Completed",
    "workflowDetails.columnError": "Error",
    "workflowDetails.columnOutput": "Output",
    "workflowDetails.columnRetries": "Retries",
    "workflowDetails.columnStarted": "Started",
    "workflowDetails.columnStatus": "Status",
    "workflowDetails.columnStep": "Step",
    "workflowDetails.contextTitle": "Context",
    "workflowDetails.errorLoading": "Failed to load workflow details. Please try again.",
    "workflowDetails.hideOutput": "Hide",
    "workflowDetails.inputTitle": "Input",
    "workflowDetails.labelCompleted": "Completed",
    "workflowDetails.labelCreated": "Created",
    "workflowDetails.labelCurrentStep": "Current Step",
    "workflowDetails.labelError": "Error",
    "workflowDetails.labelProgress": "Progress",
    "workflowDetails.labelStatus": "Status",
    "workflowDetails.labelType": "Type",
    "workflowDetails.labelUpdated": "Updated",
    "workflowDetails.labelVersion": "Version",
    "workflowDetails.noData": "No data",
    "workflowDetails.pageDescription": "Workflow run details",
    "workflowDetails.pageTitle": "Workflow Details",
    "workflowDetails.showOutput": "Show",
    "workflowDetails.steps": "steps",
    "workflowDetails.stepsTitle": "Steps",
    "workflowDetails.summaryTitle": "Workflow Details",
    "workflowDetails.viewDetails": "View",
    "workflowDetails.viewGraph": "Graph",
    "workflowDetails.viewResults": "View Results",
    "workflowDetails.viewTable": "Table",
    "workflowDetails.labelParallelKey": "Parallel Key",
    "workflowDetails.columnDetails": "Details",
    "workflowStepDetails.breadcrumbWorkflow": "Workflow",
    "workflowStepDetails.breadcrumbWorkflows": "Workflows",
    "workflowStepDetails.errorLoading": "Failed to load step details. Please try again.",
    "workflowStepDetails.labelCompleted": "Completed",
    "workflowStepDetails.labelError": "Error",
    "workflowStepDetails.labelParallelKey": "Parallel Key",
    "workflowStepDetails.labelRetries": "Retries",
    "workflowStepDetails.labelStarted": "Started",
    "workflowStepDetails.labelStatus": "Status",
    "workflowStepDetails.labelStep": "Step",
    "workflowStepDetails.outputTitle": "Output",
    "workflowStepDetails.pageDescription": "Workflow step details",
    "workflowStepDetails.pageTitle": "Step Details",
    "workflowStepDetails.scraperJobsTitle": "Scraper Jobs",
    "workflowStepDetails.stepNotFound": "Step not found",
    "workflowStepDetails.summaryTitle": "Step Details",
    "workflowResults.breadcrumbResults": "Results",
    "workflowResults.breadcrumbWorkflow": "Workflow",
    "workflowResults.breadcrumbWorkflows": "Workflows",
    "workflowResults.errorLoading": "Failed to load results. Please try again.",
    "workflowResults.inputTitle": "Input",
    "workflowResults.noResults": "No results available yet.",
    "workflowResults.pageDescription": "Workflow results",
    "workflowResults.pageTitle": "Workflow Results",
    "artifactsList.columnCreated": "Created",
    "artifactsList.columnName": "Name",
    "artifactsList.columnType": "Type",
    "artifactsList.columnActions": "Actions",
    "artifactsList.errorLoading": "Failed to load artifacts. Please try again.",
    "artifactsList.noArtifacts": "No artifacts yet.",
    "artifactsList.title": "Artifacts",
    "artifactDetails.breadcrumbArtifacts": "Artifacts",
    "artifactDetails.breadcrumbDetails": "Details",
    "artifactDetails.dataTitle": "Artifact Data",
    "artifactDetails.errorLoading": "Failed to load artifact. Please try again.",
    "artifactDetails.labelCreated": "Created",
    "artifactDetails.labelName": "Name",
    "artifactDetails.labelStepId": "Step ID",
    "artifactDetails.labelType": "Type",
    "artifactDetails.labelWorkflowRun": "Workflow Run",
    "artifactDetails.pageDescription": "Artifact details",
    "artifactDetails.pageTitle": "Artifact Details",
    "artifactDetails.summaryTitle": "Summary",
    "workflowsList.columnActions": "Actions",
    "workflowsList.columnCreated": "Created",
    "workflowsList.columnProgress": "Progress",
    "workflowsList.columnStatus": "Status",
    "workflowsList.columnType": "Type",
    "workflowsList.errorLoading": "Failed to load workflows. Please try again.",
    "workflowsList.noWorkflows": "No workflow runs yet.",
    "workflowsList.title": "Workflows",
    "workflowsList.viewDetails": "View Details",
    "workflowsList.viewResults": "Results",
    "workspaceDashboard.description": "Manage and track your forms with visual status overview",
    "workspaceDashboard.kanban.created": "Created",
    "workspaceDashboard.kanban.formCount_one": "{{count}} form",
    "workspaceDashboard.kanban.formCount_other": "{{count}} forms",
    "workspaceDashboard.kanban.noForms": "No forms",
    "workspaceDashboard.kanban.sections": "{{completed}}/{{total}} sections",
    "workspaceDashboard.kanban.status.archived": "Archived",
    "workspaceDashboard.kanban.status.completed": "Ready for Submission",
    "workspaceDashboard.kanban.status.in_progress": "In Progress",
    "workspaceDashboard.kanban.status.not_started": "Not Started",
    "workspaceDashboard.title": "Forms Dashboard",
    "workspaceMembers.actions": "Actions",
    "workspaceMembers.addFirstMember": "Add First Member",
    "workspaceMembers.addMember": "Add Member",
    "workspaceMembers.added": "Added",
    "workspaceMembers.cancel": "Cancel",
    "workspaceMembers.confirmRemoveMessage":
        "Are you sure you want to remove this member from the workspace? They will lose access to all forms and data.",
    "workspaceMembers.email": "Email",
    "workspaceMembers.failedToLoad": "Failed to load workspace members",
    "workspaceMembers.makeAdmin": "Make Admin",
    "workspaceMembers.makeMember": "Make Member",
    "workspaceMembers.noActionsAvailable": "No actions available",
    "workspaceMembers.noMembers": "No members in this workspace",
    "workspaceMembers.remove": "Remove",
    "workspaceMembers.removeFromWorkspace": "Remove from workspace",
    "workspaceMembers.removeMember": "Remove Member",
    "workspaceMembers.role": "Role",
    "workspaceMembers.youLabel": "(You)",
    "workspaceSettings.agencyName": "Agency Name",
    "workspaceSettings.agencyNamePlaceholder": "Enter your agency or company name",
    "workspaceSettings.agencyPhoto": "Agency Logo",
    "workspaceSettings.agencyPhotoUrlPlaceholder": "https://example.com/logo.png",
    "workspaceSettings.changePhoto": "Change Photo",
    "workspaceSettings.contactAddress": "Contact Address",
    "workspaceSettings.contactAddressPlaceholder": "Enter your business address",
    "workspaceSettings.contactEmail": "Contact Email",
    "workspaceSettings.contactEmailPlaceholder": "contact@agency.com",
    "workspaceSettings.contactPhone": "Contact Phone",
    "workspaceSettings.contactPhonePlaceholder": "+1 (555) 123-4567",
    "workspaceSettings.orEnterPhotoUrl": "Or enter photo URL",
    "workspaceSettings.photoRequirements": "Square images work best. Max 2MB. Will be resized to 400x400px.",
    "workspaceSettings.removePhoto": "Remove Photo",
    "workspaceSettings.uploadErrorInvalidType": "Please select a valid image file.",
    "workspaceSettings.uploadErrorProcessing": "Error processing image. Please try again.",
    "workspaceSettings.uploadErrorTooLarge": "File size must be less than 2MB.",
    "workspaceSettings.uploadPhoto": "Upload Photo",
    "workspaceSettings.whitelabelDescription": "Customize your agency branding and contact information for client-facing forms.",
    "workspaceSettings.whitelabelHeading": "Branding & Contact Information",
    "workspaceSettings.whitelabelUpdateError": "Failed to update branding settings. Please try again.",
    "workspaceSettings.whitelabelUpdateSuccess": "Branding settings updated successfully!",
    "workspaceSettingsPage.description": "Manage your workspace members, roles, and settings",
    "workspaceSettingsPage.inviteDescription": "Invite team members to collaborate on forms and manage their access levels",
    "workspaceSettingsPage.manageMembersDescription": "Manage your workspace members and their roles",
    "workspaceSettingsPage.noWorkspaceSelected": "No workspace selected",
    "workspaceSettingsPage.teamMembersHeading": "Team Members",
    "workspaceSettingsPage.title": "Workspace Settings",
    "workspaceSwitcher.businessWorkspace": "Business Workspace",
    "workspaceSwitcher.noWorkspace": "No workspace",
    "workspaceSwitcher.personalWorkspace": "Personal Workspace",
    "workspaceSwitcher.selectWorkspace": "Select workspace",
    "workspaceSwitcher.workspace": "Workspace",
    "workspacesPage.actions.goToForms": "Go to Workflows",
    "workspacesPage.actions.switchAndGoToForms": "Switch & Go to Workflows",
    "workspacesPage.description": "Select and manage your workspaces",
    "workspacesPage.noWorkspaces.description": "You don't have access to any workspaces yet.",
    "workspacesPage.noWorkspaces.title": "No workspaces",
    "workspacesPage.selectWorkspaceSubtitle": "Choose a workspace to manage your forms and submissions",
    "workspacesPage.selectWorkspaceTitle": "Select Workspace",
    "workspacesPage.status.available": "Available",
    "workspacesPage.status.current": "Current",
    "workspacesPage.tableHeaders.actions": "Actions",
    "workspacesPage.tableHeaders.status": "Status",
    "workspacesPage.tableHeaders.type": "Type",
    "workspacesPage.tableHeaders.workspace": "Workspace",
    "workspacesPage.title": "Workspaces",
};

export default en;
